// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   Margin trading page — leverage trigger + Adjust Leverage modal
   (Loaded from margin/index.js; scoped with .agce-margin- prefix.)
   ============================================================================= */

.agce-margin-leverage-row {
  padding: 4px 10px 8px;
}

.pnl-green {
  color: #008000 !important;
}

.pnl-danger {
  color: #ff0000 !important;
}

.agce-margin-leverage-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: inherit;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}

.agce-margin-leverage-trigger:hover {
  opacity: 0.8;
}


.agce-margin-leverage-label {
  color: #94a3b8;
  font-weight: 500;
}

body.light_theme .agce-margin-leverage-label {
  color: #64748b;
}

.agce-margin-leverage-value {
  color: #e2e8f0;
  font-weight: 600;
}

body.light_theme .agce-margin-leverage-value {
  color: #0f172a;
}

/* --- NO-DATA CENTERING --- */
.spot_orders_no_data_row {
  width: 100% !important;
  display: table-row !important;
}

.spot_orders_no_data_row td {
  width: 100% !important;
  display: table-cell !important;
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0 !important;
}

.spot_orders_empty_state {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  width: 100% !important;
  /* min-height: 600px !important; */
  padding: 48px 0 !important;
}

.spot_orders_empty_telescope {
  display: block !important;
  margin: 0 auto !important;
}

/* -------------------------- */

.agce-margin-leverage-trigger i {
  font-size: 18px;
  opacity: 0.85;
  margin-left: 2px;
}

/* Spot / Cross / Isolated / ETF / Futures — single row + horizontal scroll when narrow */
.agce-margin-surface-tabs-outer {
  min-width: 0;
}

.agce-margin-surface-tabs-scroll-wrap {
  min-width: 0;
  flex: 1 1 auto;
}

.agce-margin-surface-tabs-scroller {
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.agce-margin-surface-tabs-scroller::-webkit-scrollbar {
  display: none;
}

.margin-surface-tabs .margin_surface_tab_strip>button {
  flex-shrink: 0;
}

.agce-margin-surface-tab-scroll-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease, opacity 0.15s ease;
}

.agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.08);
}

.agce-margin-surface-tab-scroll-btn:disabled {
  opacity: 0.28;
  cursor: default;
  pointer-events: none;
}

body.light_theme .agce-margin-surface-tab-scroll-btn {
  color: #84888c;
}

body.light_theme .agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {
  color: #0f172a;
  background: rgba(15, 23, 42, 0.06);
}

/* ——— Modal ——— */
.agce-margin-lvg-modal-root {
  position: fixed;
  inset: 0;
  z-index: 10600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  z-index: 99999999;
}

.agce-margin-lvg-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgb(255 255 255 / 20%);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.agce-margin-lvg-modal-panel {
  position: relative;
  width: 100%;
  max-width: 540px;
  border-radius: 14px;
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);
  font-family: "Inter", sans-serif;
  overflow: hidden;
}

.agce-margin-lvg-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 12px;
  border-bottom: 1px solid #e2e8f0;
}

.agce-margin-lvg-modal-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.agce-margin-lvg-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.agce-margin-lvg-modal-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-margin-lvg-modal-body {
  padding: 16px 18px 8px;
}

.agce-margin-lvg-field-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 6px;
}

.agce-margin-lvg-coin-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 18px;
}

.agce-margin-lvg-coin-row img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.agce-margin-lvg-input-wrap {
  position: relative;
  margin-bottom: 12px;
}

.agce-margin-lvg-input {
  width: 100%;
  padding: 12px 40px 12px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  outline: none;
}

.agce-margin-lvg-input:focus {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.08);
}

.agce-margin-lvg-stepper {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.agce-margin-lvg-stepper button {
  width: 22px;
  height: 12px;
  border: none;
  background: none;
  border-radius: 4px;
  font-size: 10px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

/* .agce-margin-lvg-stepper button:hover {
  background: #e2e8f0;
} */

.agce-margin-lvg-quick {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
}

.agce-margin-lvg-quick button {
  min-width: 52px;
  padding: 8px 6px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}

.agce-margin-lvg-quick button:hover {
  background: #e2e8f0;
}

.agce-margin-lvg-quick button.is-active {
  border-color: #0f172a;
  background: #fff;
  color: #0f172a;
}

.agce-margin-lvg-stats {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.agce-margin-lvg-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.agce-margin-lvg-stat dt {
  margin: 0;
  color: #64748b;
  font-weight: 500;
}

.agce-margin-lvg-stat dd {
  margin: 0;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 4px;
}

.agce-margin-lvg-warn {
  font-size: 12px;
  line-height: 1.45;
  color: #ea580c;
  margin: 0 0 8px;
}

.agce-margin-lvg-modal-foot {
  display: flex;
  gap: 10px;
  padding: 14px 18px 18px;
}

.agce-margin-lvg-btn {
  flex: 1 1;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.agce-margin-lvg-btn--ghost {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-margin-lvg-btn--ghost:hover {
  background: #e2e8f0;
}

.agce-margin-lvg-btn--primary {
  background: #0f172a;
  color: #fff;
}

.agce-margin-lvg-btn--primary:hover {
  background: #1e293b;
}

/* ——— Advanced Limit — Order Type modal ——— */
.agce-margin-ordty-modal-root {
  position: fixed;
  inset: 0;
  z-index: 9999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
}

.agce-margin-ordty-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgb(255 255 255 / 20%);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.agce-margin-ordty-modal-panel {
  position: relative;
  width: 100%;
  max-width: 440px;
  max-height: min(92vh, 640px);
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);
  font-family: "Inter", sans-serif;
  overflow: hidden;
}

.agce-margin-ordty-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 16px 18px 12px;
  border-bottom: 1px solid #e2e8f0;
}

.agce-margin-ordty-modal-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.agce-margin-ordty-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.agce-margin-ordty-modal-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-margin-ordty-modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 14px 18px 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agce-margin-ordty-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  margin: 0;
  padding: 12px 14px;
  text-align: left;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.agce-margin-ordty-option:hover {
  border-color: #cbd5e1;
}

.agce-margin-ordty-option.is-selected {
  border-width: 1px;
  border-color: #c6c6c6;
  padding: 11px 13px;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.06);
}

.agce-margin-ordty-option-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.agce-margin-ordty-option-desc {
  font-size: 13px;
  line-height: 1.45;
  font-weight: 500;
  color: #64748b;
}

.agce-margin-ordty-modal-foot {
  flex-shrink: 0;
  padding: 14px 18px 18px;
}

.agce-margin-ordty-btn-confirm {
  width: 100%;
  padding: 14px 16px;
  border-radius: 10px;
  border: none;
  background: #0f172a;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  cursor: pointer;
}

.agce-margin-ordty-btn-confirm:hover {
  background: #1e293b;
}



/* TP/SL — one Market/Limit toggle; same fill + radius as .trade_price_field (trade_new.css) */
.agce-margin-tp-sl-price-row {
  flex-wrap: nowrap;
}

.agce-margin-tp-sl-toggle-btn {
  flex-shrink: 0;
  align-self: stretch;
  min-width: 72px;
  height: 40px;
  margin: 0;
  padding: 0 14px;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: #f6f6f7;
  color: #070808;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.agce-margin-tp-sl-toggle-btn:hover {
  background: #ececed;
}

.agce-margin-tp-sl-toggle-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);
}

body.light_theme .agce-margin-tp-sl-toggle-btn {
  background: #f6f6f7;
  color: #070808;
}

body.light_theme .agce-margin-tp-sl-toggle-btn:hover {
  background: #ececed;
}

/* Conditional — Order Price: strong border when execution is Market (matches mobile ref). */
.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed="false"] {
  background: #f5f5f5;
  font-weight: 500;
}

.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed="true"] {
  border: 1px solid #e2e8f0;
}

/* TP/SL + TWAP + Iceberg — extra breathing room for quote/base suffix (USDT, BTC) inside filled rows */
.margin-advanced-block--tp-sl .trade_price_suffix,
.margin-advanced-block--twap .trade_price_suffix,
.margin-advanced-block--iceberg .trade_price_suffix,
.margin-advanced-block--loop .trade_price_suffix,
.margin-advanced-block--trail .trade_price_suffix,
.margin-advanced-block--adv-lim .trade_price_suffix,
.margin-advanced-block--cond .trade_price_suffix {
  padding-left: 10px;
  padding-right: 14px;
}

.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text,
.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,
.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text {
  padding-left: 10px !important;
  padding-right: 14px !important;
  min-width: 3.25rem;
  justify-content: center;
}

/* Loop Order — price row (optional + quote | mode), Valid for row, dropdown menus */
.trade_price_field.agce-margin-loop-price-row {
  position: relative;
  align-items: center;
  padding-right: 4px;
}

.agce-margin-loop-price-quote {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  padding-right: 2px;
}

.agce-margin-loop-price-bar {
  flex-shrink: 0;
  padding: 0 6px;
  font-size: 14px;
  font-weight: 500;
  color: #c3c6c8;
  -webkit-user-select: none;
          user-select: none;
}

.agce-margin-loop-price-mode {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: stretch;
  align-self: stretch;
  margin-left: 4px;
  padding-left: 6px;
  border-left: 1px solid #dfe0e2;
}

.agce-margin-loop-price-mode-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0 8px 0 4px;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
}

.agce-margin-loop-price-mode-btn:focus-visible {
  box-shadow: none;
}

.agce-margin-loop-price-mode-chev {
  font-size: 18px;
  color: #64748b;
  line-height: 1;
  margin-left: 2px;
}

.agce-margin-loop-price-row.is-open .agce-margin-loop-price-mode-chev,
.agce-margin-loop-valid-wrap.is-open .agce-margin-loop-valid-chev {
  color: #475569;
}

.trade_price_field.agce-margin-loop-valid-wrap {
  position: relative;
  padding: 0;
}

.agce-margin-loop-valid-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  margin: 0;
  padding: 0 12px 0 12px;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #070808;
  text-align: left;
  cursor: pointer;
  outline: none;
}

.agce-margin-loop-valid-btn:focus-visible {
  box-shadow: none;
}

.agce-margin-loop-valid-btn__text {
  flex: 1 1 auto;
  min-width: 0;
}

.agce-margin-loop-valid-chev {
  font-size: 18px;
  color: #64748b;
  line-height: 1;
  flex-shrink: 0;
  margin-left: 8px;
}

.agce-margin-loop-price-mode .agce-margin-loop-pick__menu {
  left: auto;
  right: 0;
  min-width: 11rem;
}

.agce-margin-loop-valid-wrap .agce-margin-loop-pick__menu {
  left: 0;
  right: 0;
}

.agce-margin-loop-pick__menu {
  position: absolute;
  top: calc(100% + 4px);
  z-index: 30;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  max-height: 240px;
  overflow-y: auto;
}

.agce-margin-loop-pick__menu-item {
  margin: 0;
  padding: 0;
}

.agce-margin-loop-pick__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 5px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.agce-margin-loop-pick__option:hover {
  background: #f1f5f9;
}

.agce-margin-loop-pick__check {
  flex-shrink: 0;
  font-size: 18px;
  color: #1e90ff;
  line-height: 1;
}

.agce-margin-loop-pick__check-slot {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
}

/* Trailing Stop — pullback: filled row + %|USDT unit menu + 5% chip */
.agce-margin-trail-pullback-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.agce-margin-trail-pullback-field.trade_price_field {
  flex: 1 1 auto;
  min-width: 0;
}

.agce-margin-trail-preset-chip {
  flex-shrink: 0;
  min-width: 52px;
  margin: 0;
  padding: 0 12px;
  box-sizing: border-box;
  height: 40px;
  align-self: stretch;
  border: none;
  border-radius: 8px;
  background: #f6f6f7;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #070808;
  cursor: pointer;
  transition: background 0.15s ease;
}

.agce-margin-trail-preset-chip:hover {
  background: #ececed;
}

.agce-margin-trail-preset-chip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);
}

.agce-margin-twap-interval-unit-wrap.agce-margin-trail-pull-unit .agce-margin-loop-pick__menu {
  left: auto;
  right: 0;
  min-width: 8rem;
}

.agce-margin-iceberg-section-title {
  margin: 0 0 10px 2px;
  padding: 0;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #1f1f1f;
}

/* TWAP — duration split (H | M), presets, advanced toggle, inline selects */
.agce-margin-twap-duration-shell {
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  background: #f6f6f7;
  border-radius: 8px;
  overflow: hidden;
  font-family: "Inter", sans-serif;
}

.agce-margin-twap-duration-cell {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 4px 0 12px;
}

.agce-margin-twap-duration-input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #070808;
  padding: 0 6px 0 0;
  line-height: 1.25;
}

.agce-margin-twap-duration-input::placeholder {
  color: #c3c6c8;
  font-weight: 500;
}

.agce-margin-twap-duration-suffix {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  padding-right: 10px;
}

.agce-margin-twap-duration-divider {
  width: 1px;
  flex-shrink: 0;
  background: #dfe0e2;
  align-self: stretch;
  margin: 6px 0;
}

.agce-margin-twap-preset-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.agce-margin-twap-preset {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 8px);
  min-width: 56px;
  height: 36px;
  margin: 0;
  padding: 0 8px;
  border: none;
  border-radius: 8px;
  background: #f0f1f3;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  cursor: pointer;
  transition: background 0.15s ease;
}

.agce-margin-twap-preset:hover {
  background: #e4e6ea;
}

.agce-margin-twap-advanced-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 0.25rem;
  padding: 10px 4px 10px 2px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: "Inter", sans-serif;
}

.agce-margin-twap-advanced-toggle__label {
  font-size: 14px;
  font-weight: 500;
}

.agce-margin-twap-advanced-toggle__icon {
  font-size: 20px;
  color: #64748b;
  line-height: 1;
}

.agce-margin-twap-advanced-panel {
  padding-top: 2px;
}

/* TWAP advanced — click-to-open value lists + chevron affordance */
.agce-margin-twap-pick-field {
  position: relative;
}

.agce-margin-twap-per-pick {
  position: relative;
}

button.agce-margin-twap-pick-rowbtn {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  min-height: 38px;
  margin: 0;
  padding: 0 10px 0 2px;
  box-sizing: border-box;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #070808;
  text-align: left;
  cursor: pointer;
  outline: none;
  gap: 6px;
}

button.agce-margin-twap-pick-rowbtn--muted {
  color: #c3c6c8;
}

button.agce-margin-twap-pick-rowbtn--per {
  min-height: calc(1.5em + 0.75rem + 2px);
}

.agce-margin-twap-pick-rowbtn__text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agce-margin-twap-pick-rowbtn__unit {
  flex-shrink: 0;
  padding-left: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #070808;
}

.agce-margin-twap-pick__chev {
  flex-shrink: 0;
  font-size: 18px;
  color: #64748b;
  line-height: 1;
  margin-left: 2px;
}

.agce-margin-twap-pick-field.is-open .agce-margin-twap-pick__chev,
.agce-margin-twap-interval-row.is-open .agce-margin-twap-pick__chev,
.agce-margin-twap-per-pick.is-open .agce-margin-twap-pick__chev {
  color: #475569;
}

/* TWAP Time Interval — one filled row: value (Limit-style input) + Hour|Minute + chevron */
.trade_price_field.agce-margin-twap-interval-row {
  position: relative;
}

.agce-margin-twap-interval-unit-wrap {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: stretch;
  align-self: stretch;
  margin-left: 7px;
  padding-left: 2px;
  border-left: 1px solid #dfe0e2;
}

.agce-margin-twap-interval-unit-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0 10px 0 8px;
  border: 0;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #070808;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
}

.agce-margin-twap-interval-unit-btn:focus-visible {
  box-shadow: none;
}

.agce-margin-twap-interval-unit-wrap .agce-margin-twap-pick__menu {
  left: auto;
  right: 0;
  min-width: 8.5rem;
}

.agce-margin-twap-pick__menu {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  z-index: 30;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  max-height: 240px;
  overflow-y: auto;
}

.agce-margin-twap-pick__menu-item {
  margin: 0;
  padding: 0;
}

.agce-margin-twap-pick__option {
  display: block;
  width: 100%;
  margin: 0;
  padding: 10px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  cursor: pointer;
}

.agce-margin-twap-pick__option:hover {
  background: #f1f5f9;
}

.agce-margin-twap-per-pick .agce-margin-twap-pick__menu {
  left: 0;
  right: 0;
}

.agce-margin-twap-est-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #475569;
}

.agce-margin-twap-est-label {
  flex: 1 1 auto;
  line-height: 1.35;
  max-width: 58%;
}

.agce-margin-twap-est-val {
  flex-shrink: 0;
  font-weight: 600;
  color: #070808;
  text-align: right;
}




/* =============================================================================
   Add Funds Modal (margin page)
   ============================================================================= */
.agcx-add-funds-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 2147483647;
  background-color: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  animation: agcx-af-fade 160ms ease-out both;
}

html[data-theme="dark"] .agcx-add-funds-overlay {
  background-color: rgb(0 0 0 / 50%);
}

.agcx-add-funds-modal {
  width: min(760px, 100%);
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: agcx-af-pop 200ms ease-out both;
}

html[data-theme="dark"] .agcx-add-funds-modal {
  background: #1e222d;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.agcx-add-funds-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
}

.agcx-add-funds-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0b0e11;
}

html[data-theme="dark"] .agcx-add-funds-title {
  color: #f8fafc;
}

.agcx-add-funds-close {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #9aa0a6;
  padding: 6px 10px;
  border-radius: 10px;
}

.agcx-add-funds-close:hover {
  color: #111827;
}

html[data-theme="dark"] .agcx-add-funds-close:hover {
  color: #f8fafc;
}

.agcx-add-funds-body {
  padding: 0px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.agcx-add-funds-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px;
  border-radius: 14px;
  border: 1px solid #eef0f2;
  background: #fff;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  color: inherit;
  font: inherit;
}

.agcx-add-funds-card:hover {
  border-color: #e5e7eb;
  background: #fbfbfc;
  text-decoration: none;
  color: inherit;
}

html[data-theme="dark"] .agcx-add-funds-card {
  border-color: #2a2e39;
  background: #1e222d;
  color: #f8fafc;
}

html[data-theme="dark"] .agcx-add-funds-card:hover {
  border-color: #3a3e49;
  background: #262a35;
  color: #f8fafc;
}

.agcx-add-funds-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #111827;
  font-size: 22px;
}

html[data-theme="dark"] .agcx-add-funds-icon {
  background: #2a2e39;
  color: #f8fafc;
}

.agcx-add-funds-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.agcx-add-funds-item-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

html[data-theme="dark"] .agcx-add-funds-item-title {
  color: #f8fafc;
}

.agcx-add-funds-desc {
  font-size: 14px;
  font-weight: 500;
  color: #8e9299;
  line-height: 1.35;
}

.agcx-add-funds-sub {
  font-size: 14px;
  font-weight: 500;
  color: #8e9299;
}

.agcx-add-funds-more {
  width: 100%;
  border: none;
  background: transparent;
  color: #070707;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 0 10px;
  cursor: pointer;
}

html[data-theme="dark"] .agcx-add-funds-more {
  color: #070707
}

@keyframes agcx-af-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes agcx-af-pop {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}



@media (max-width: 767px) {

  .agcx-add-funds-overlay {
    align-items: end;
    padding: 0px;
  }

  .agce-margin-lvg-modal-root {
    align-items: end;
  }

  .agcx-add-funds-modal {
    border-radius: 14px 14px 0px 0px;
  }

  .agce-margin-lvg-modal-panel {
    border-radius: 14px 14px 0px 0px;
    max-width: 100%;
  }

  .agce-margin-ordty-modal-root {
    align-items: end;
  }


  .agce-margin-ordty-modal-panel {
    width: 100%;
    max-width: 100%;
    border-radius: 14px 14px 0px 0px;
  }

}

@media (max-width: 576px) {

  .agcx-add-funds-head {
    padding: 16px 18px;
  }

  .agcx-add-funds-body {
    padding: 0px 18px 14px;
    gap: 10px;
  }

  .agcx-add-funds-card {
    padding: 14px;
    gap: 14px;
  }

  .agcx-add-funds-icon {
    width: 38px;
    height: 38px;
    font-size: 18px;
  }

  .agcx-add-funds-item-title {
    font-size: 15px;
  }

  .agcx-add-funds-desc {
    font-size: 13px;
  }
}

/* --- Percentage of Volume (POV) Order Fields --- */
.agce-margin-pov-rates-container {
  margin-top: 4px;
}

.agce-margin-pov-rate-btn {
  font-size: 13px !important;
  padding: 7px 8px !important;
  border-radius: 4px;
}

span.agce-margin-twap-advanced-toggle__label.text-dark.fw-bold.agce-margin-pov-adv-toggle-label {
  font-weight: 500 !important;
}

button.agce-margin-pov-rate-btn:focus {
  background-color: #f8f9fa !important;
  border: 1px solid #000 !important;
}

.agce-margin-pov-valid-select {
  height: 40px;
}

.agce-margin-pov-adv-toggle-label {
  font-size: 14px;
}

.agce-margin-pov-adv-input-group {
  border-radius: 4px;
  overflow: hidden;
}

.agce-margin-pov-dotted-label {
  text-decoration: underline;
  text-decoration-style: dotted;
}

/* Order type tabs scroller styles */
.agce-margin-order-tabs-outer {
  position: relative;
  overflow: visible !important;
  flex-wrap: nowrap !important;
}

/* .agce-margin-order-tabs-scroller {
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none; 
} */

.agce-margin-order-tabs-scroller::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

.agce-margin-order-tabs-scroller .spot_limit {
  display: flex;
  align-items: center;
  flex-wrap: nowrap !important;
}

.agce-margin-order-tabs-scroller .spot_limit button,
.agce-margin-order-tabs-scroller .spot_limit_dropdown {
  flex-shrink: 0 !important;
}

.agce-margin-order-tab-scroll-btn-left,
.agce-margin-order-tab-scroll-btn-right {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  color: #8E949E;
}

.agce-margin-order-tab-scroll-btn-left:disabled,
.agce-margin-order-tab-scroll-btn-right:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* Futures Margin Balance Row Styles */
.agce-futures-margin-dotted-label {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 4px;
  cursor: help;
}

.agce-futures-margin-value-container {
  font-weight: 500;
  font-family: "Inter", sans-serif;
  display: flex;
  align-items: center;
}

.agce-futures-margin-val-green {
  color: #03c087 !important;
  font-weight: 600;
}

.agce-futures-margin-divider {
  color: #64748b;
  margin: 0 4px;
}

.agce-futures-margin-val-red {
  color: #ef4444 !important;
  font-weight: 600;
}

.agce-futures-margin-currency {
  font-weight: 500;
  margin-left: 4px;
}

body.light_theme .agce-futures-margin-divider {
  color: #94a3b8;
}

/* Futures Points Card Styles */
.agce-futures-points-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #edeff2;
  border-radius: 8px;
  padding: 10px 14px;
  background: #ffffff;
  text-decoration: none !important;
  transition: all 0.2s ease;
  cursor: pointer;
  width: 100%;
}

/* .agce-futures-points-card:hover {
  background: #fbfbfc;
  border-color: #e2e8f0;
}

body.dark-mode .agce-futures-points-card,
html[data-theme="dark"] .agce-futures-points-card {
  border-color: #2a2e39;
  background: #1e222d;
}

body.dark-mode .agce-futures-points-card:hover,
html[data-theme="dark"] .agce-futures-points-card:hover {
  background: #262a35;
  border-color: #3a3e49;
} */

.agce-futures-points-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.agce-futures-points-badge-icon {
  width: 24px;
  height: 24px;
  background: #e6f9f3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00c087;
  font-size: 14px;
  flex-shrink: 0;
}

body.dark-mode .agce-futures-points-badge-icon,
html[data-theme="dark"] .agce-futures-points-badge-icon {
  background: rgba(0, 192, 135, 0.15);
}

.agce-futures-points-text {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 700;
  font-style: italic;
  color: #00c087;
  display: flex;
  align-items: center;
  gap: 4px;
}

.agce-futures-points-spark {
  font-size: 12px;
  font-style: normal;
}

.agce-futures-points-right {
  color: #94a3b8;
  font-size: 16px;
  display: flex;
  align-items: center;
}

/* Filter bar for margin trading history tables */
.trade_summary_table_lft_position_order .agce-margin-filter-bar {
  background: transparent !important;
  flex-wrap: nowrap !important;
  gap: 6px;
  padding: 12px 0 5px;
  align-items: center;
}

.trade_summary_table_lft_position_order .agce-margin-filter-bar::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}


.trade_account_summary_assets .mobile_view2 {
  display: none;
}

.trade_summary_table_lft_position_order .agce-margin-filter-select {
  flex-shrink: 0;
  width: auto;
  min-width: 90px;
  max-width: 130px;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 4px;
  cursor: pointer;
}

.trade_summary_table_lft_position_order .agce-margin-filter-btn {
  flex-shrink: 0;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 4px;
  cursor: pointer;
  background: #f6f6f7;
  border: 1px solid #f6f6f7;
  font-weight: 400;
}

.trade_summary_table_lft_position_order .agce-margin-filter-btn.active {
  border: 1px solid #d1d5db;
  font-weight: 600;
}

.trade_summary_table_lft_position_order .agce-margin-filter-input {
  width: 130px;
  font-size: 12px;
  padding: 6px 6px;
  border-radius: 4px;
  border: 1px solid #f6f6f712;
  color: #959595;
  background: #f6f6f714;
  color-scheme: dark;
}

.agce-margin-date-input-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.agce-margin-date-input-wrap[data-empty="true"]::before {
  content: attr(data-placeholder);
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #959595;
  font-size: 12px;
  pointer-events: none;
  z-index: 1;
}

body.light_theme .agce-margin-date-input-wrap[data-empty="true"]::before {
  color: #6b7280;
}

.agce-margin-date-input-wrap[data-empty="true"] .agce-margin-filter-input::-webkit-datetime-edit-text,
.agce-margin-date-input-wrap[data-empty="true"] .agce-margin-filter-input::-webkit-datetime-edit-month-field,
.agce-margin-date-input-wrap[data-empty="true"] .agce-margin-filter-input::-webkit-datetime-edit-day-field,
.agce-margin-date-input-wrap[data-empty="true"] .agce-margin-filter-input::-webkit-datetime-edit-year-field {
  color: transparent !important;
}


.trade_summary_table_lft_position_order .agce-margin-filter-arrow {
  font-size: 12px;
}

.trade_summary_table_lft_position_order .agce-margin-filter-reset {
  flex-shrink: 0;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 4px;
  border: none;
  background: none;
  cursor: pointer;
}

/* Subtabs layout for margin trading history tables */
.trade_summary_table_lft_position_order .agce-margin-subtabs {
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin: 12px 0px 6px;
  gap: 8px;
}

/* body.light_theme .trade_summary_table_lft_position_order .agce-margin-subtabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
} */

.trade_summary_table_lft_position_order .agce-margin-subtab-btn {
  background: #F6F6F7;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 400;
  border-bottom: 2px solid transparent;
  /* margin-bottom: -1px; */
  color: #8E949E;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.trade_summary_table_lft_position_order .agce-margin-subtab-btn:hover {
  color: #fff;
}

.trade_summary_table_lft_position_order .agce-margin-subtab-btn.active {
  font-weight: 600;
  color: #fff;
}

body.light_theme .trade_summary_table_lft_position_order .agce-margin-subtab-btn {
  color: #4b5563;
}

body.light_theme .trade_summary_table_lft_position_order .agce-margin-subtab-btn:hover {
  color: #111827;
}

body.light_theme .trade_summary_table_lft_position_order .agce-margin-filter-input {
  border: 1px solid #f6f6f7;
  color: #111827;
  background: #f6f6f7;
  color-scheme: light;
}

body.light_theme .trade_summary_table_lft_position_order .agce-margin-filter-input::-webkit-calendar-picker-indicator {
  filter: none;
}

button.agce-margin-surface-tab-scroll-btn.ms-1.flex-shrink-0:hover {
  background: none !important;
}

body.light_theme .trade_summary_table_lft_position_order .agce-margin-subtab-btn.active {
  color: #111827;
}

span.input-group-text.text-start.stop_amt_suffix.trade_amount_coin_badge {
  display: flex !important;
  justify-content: end;
  color: #000;
}



/* Sticky top header for trade account summary on mobile */
@media (max-width: 991.98px) {

  /* Container sticks to the window at 80px down */
  .trade_account_summary_assets {
    position: sticky !important;
    top: 80px !important;
    z-index: 100;
  }


  .agce-margin-pos-val-primary {
    font-size: 12px;
  }

  /* When the container is stuck at the top, it takes the remaining viewport height */
  .trade_account_summary_assets.is-stuck {
    height: calc(100vh - 80px) !important;
  }

  /* When stuck, the table container becomes internally scrollable */
  .trade_account_summary_assets.is-stuck .mobile_view2,
  .trade_account_summary_assets.is-stuck .order_history_mobile_view {
    max-height: calc(100vh - 80px - 55px) !important;
    /* 55px accounts for the sticky tabs header */
    overflow-y: auto !important;
  }

  /* When NOT stuck, everything displays fully and scrolls natively with the page */
  .trade_account_summary_assets:not(.is-stuck) .mobile_view2,
  .trade_account_summary_assets:not(.is-stuck) .order_history_mobile_view {
    max-height: none !important;
    overflow-y: visible !important;
  }

  .trade_account_summary_assets .mobile_view2 {
    padding-bottom: 90px;
  }

  .trade_summary_table_lft_position_order.position_order {
    overflow: visible !important;
  }

  /* Header sticks to the top of the internal scroll container */
  .trade_account_summary_assets .spot_orders_top {
    position: sticky !important;
    top: 0 !important;
    z-index: 999;
    box-shadow: 0 0px 1px 0px rgba(0, 0, 0, 0.1);
  }

  /* Force a solid background so scrolling rows don't show through */
  body.light_theme .trade_account_summary_assets .spot_orders_top {
    background: #ffffff !important;
  }

  .trade_account_summary_assets .mobile_view2 {
    max-height: none !important;
  }
}

/* Mobile Filter Popup Classes */
.spot_orders_filter_bar.agce-margin-filter-bar {
  flex-wrap: wrap;
  overflow-x: visible;
}

.agce-margin-filter-toggle-btn {
  border-radius: 6px;
  font-size: 13px;
  background: transparent;
  border: 1px solid #4a4a4a;
  color: inherit;
}

.agce-filter-overlay-active {
  display: flex !important;
  z-index: 99999999;
}

.agce-margin-filter-popup .agce-margin-filter-select {
  min-width: 100% !important;
  max-width: 100% !important;
}

.agce-margin-filter-popup .agce-margin-filter-input {
  width: 100%;
}

.agce-margin-filter-popup h6 {
  color: #070808;
}

.agce-margin-filter-popup {
  height: auto !important;
  max-height: 80vh !important;
  padding-bottom: 60px;
}

.agce-margin-filter-popup-content {
  background: transparent !important;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 10px;
  padding-bottom: 15px !important;
}

.agce-margin-filter-popup-content>* {
  grid-column: 1 / -1;
}

.agce-margin-filter-popup-content>.agce-margin-filter-btn {
  grid-column: span 1;
}

.agce-margin-filter-popup-content>.agce-margin-filter-arrow {
  display: none !important;
}

.agce-margin-filter-apply-btn {
  background: #000000 !important;
  border: none !important;
  border-radius: 50px !important;
  font-weight: 600 !important;
  padding: 8px !important;
  font-size: 13px;
  color: white;
}

.agce-margin-filter-apply-btn:hover,
.agce-margin-filter-apply-btn:active {
  background: #141414 !important;
}

.agce-margin-filter-checkbox-group {
  margin-left: auto;
  display: flex;
  gap: 14px;
  align-items: center;
  flex-shrink: 0;
}

.agce-margin-filter-checkbox-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.agce-margin-filter-popup-content>.agce-margin-filter-checkbox-group {
  grid-column: 1 / -1;
  margin-left: 0;
  justify-content: flex-start;
}

/* Mobile Asset History Card Classes */
.agce-margin-card-wrap {
  min-height: 200px;
}

.agce-margin-card-empty {
  font-size: 12px;
  color: #8e949e;
}

.agce-margin-card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.agce-margin-card-pair {
  font-weight: 600;
}

.agce-margin-card-time {
  font-size: 11px;
  color: #8e949e;
}

.agce-margin-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 12px;
  font-size: 12px;
}

.agce-margin-card-label {
  color: #8e949e;
}

.agce-margin-card-success {
  color: #01bc8d;
}

.agce-margin-card-danger {
  color: #e45561;
}

.agce-margin-card-grid>div:nth-child(even) {
  text-align: right;
}

/* Position History Cards */
.agce-margin-pos-card {
  border-bottom: 1px solid var(--border-color, #efefef);
  padding: 12px 16px;
}

html[data-theme="dark"] .agce-margin-pos-card {
  border-bottom: 1px solid #2b313c;
}

.agce-margin-pos-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.agce-margin-pos-cell {
  flex: 1 1;
}

.agce-margin-pos-cell.text-right {
  text-align: right;
}

.agce-margin-pos-lbl {
  font-size: 11px;
  color: #8e949e;
  margin-bottom: 2px;
}

.agce-margin-pos-val-primary {
  font-weight: 500;
}

.agce-margin-pos-val-secondary {
  color: #8e949e;
}

.agce-margin-pos-pair-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
}

.agce-margin-pos-pair {
  font-weight: 700;
  font-size: 14px;
}

.agce-margin-pos-tag {
  background: var(--bg-secondary, #f0f1f2);
  border-radius: 4px;
  padding: 1px 7px;
  font-size: 12px;
}

html[data-theme="dark"] .agce-margin-pos-tag {
  background: #2b313c;
}

.agce-margin-pos-side-val {
  font-weight: 700;
  font-size: 15px;
  margin-top: 2px;
}

.agce-margin-pos-asset {
  color: #8e949e;
  font-size: 11px;
  margin-left: 3px;
}

.agce-margin-mobile-filter-wrap {
  display: none;
}


@media (max-width: 1200px) {
  .agce-margin-leverage-row {
    padding-left: 8px;
    padding-right: 8px;
  }

  .agce-margin-mobile-filter-wrap {
    display: block;
  }

  .trade_account_summary_assets .mobile_view2 {
    display: block;
  }

  .agce-margin-filter-popup {
    padding-bottom: 10px;
  }

}


@media (max-width: 991px) {


  .agce-margin-filter-popup {
    padding-bottom: 60px;
  }

  .agcx-add-funds-title {
    font-size: 18px;
  }

  .agcx-add-funds-close {
    font-size: 24px;
    padding: 0px;
  }

  .order_history_mobile_view .agce-margin-pos-card {
    padding: 12px 0px;
  }

}

.agce-margin-order-type-container {
  display: flex;
  overflow-x: auto;
  gap: 6px;
  padding: 4px 0 6px;
  align-items: center;
}

.agce-margin-order-type-btn {
  flex-shrink: 0;
  font-size: 12px;
  padding: 3px 12px;
  border-radius: 4px;
  cursor: pointer;
  background: none;
  border: none;
  font-weight: 400;
  white-space: nowrap;
}

.agce-margin-order-type-btn.active {
  background: #F6F6F7;
  font-weight: 600;
}

/* --- LEVERAGE TOGGLE SWITCH UI --- */
.agce-margin-leverage-trigger-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 4px 0 8px;
  cursor: pointer;
  outline: none;
  font-family: "Inter", sans-serif;
}

/* Switch container wrapper */
.agce-margin-leverage-switch-visual {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  pointer-events: none;
  /* Let click pass to the button */
}

/* Slider styling */
.agce-margin-leverage-slider-visual {
  position: absolute;
  inset: 0;
  background-color: #cbd5e1;
  /* Off: gray */
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 999px;
}

/* Slider knob */
.agce-margin-leverage-slider-visual:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

/* Active status styles */
.agce-margin-leverage-slider-visual.is-active {
  background-color: #d0aa67 !important;
  /* Premium Emerald green */
}

.agce-margin-leverage-slider-visual.is-active:before {
  transform: translateX(14px);
}

.agce-margin-leverage-label {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.15s ease;
}

.agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {
  color: #0f172a;
}

.agce-margin-leverage-value {
  color: #0f172a;
  font-weight: 600;
  font-size: 14px;
}

.agce-margin-leverage-trigger-btn i {
  font-size: 16px;
  color: #64748b;
  margin-left: 2px;
}

/* Dark mode compatibility */
body.dark_theme .agce-margin-leverage-slider-visual {
  background-color: #475569;
}

body.dark_theme .agce-margin-leverage-label {
  color: #94a3b8;
}

body.dark_theme .agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {
  color: #f8fafc;
}

body.dark_theme .agce-margin-leverage-value {
  color: #f8fafc;
}

/* ==========================================
   Dark Theme (Default) Overrides for Modals
   ========================================== */
body:not(.light_theme) .agce-margin-lvg-modal-backdrop,
body:not(.light_theme) .agce-margin-ordty-modal-backdrop {
  background: rgba(0, 0, 0, 0.7);
}

body:not(.light_theme) .agce-margin-lvg-modal-panel,
body:not(.light_theme) .agce-margin-ordty-modal-panel {
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-modal-head,
body:not(.light_theme) .agce-margin-ordty-modal-head {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .agce-margin-lvg-modal-title,
body:not(.light_theme) .agce-margin-ordty-modal-title {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-modal-close,
body:not(.light_theme) .agce-margin-ordty-modal-close {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-lvg-modal-close:hover,
body:not(.light_theme) .agce-margin-ordty-modal-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-field-label {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-lvg-coin-row {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-input {
  border-color: rgba(255, 255, 255, 0.15);
  background: #1e2329;
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-input:focus {
  border-color: #ffffff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .agce-margin-lvg-quick button {
  border-color: rgba(255, 255, 255, 0.1);
  background: #1e2329;
  color: #e2e8f0;
}

body:not(.light_theme) .agce-margin-lvg-quick button:hover {
  background: rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .agce-margin-lvg-quick button.is-active {
  border-color: #ffffff;
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .agce-margin-lvg-stat dt {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-lvg-stat dd {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-btn--ghost {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-lvg-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.15);
}

body:not(.light_theme) .agce-margin-lvg-btn--primary {
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .agce-margin-lvg-btn--primary:hover {
  background: #e2e8f0;
}

body:not(.light_theme) .agce-margin-ordty-option {
  border-color: rgba(255, 255, 255, 0.1);
  background: #1e2329;
}

body:not(.light_theme) .agce-margin-ordty-option:hover {
  border-color: rgba(255, 255, 255, 0.2);
}

body:not(.light_theme) .agce-margin-ordty-option.is-selected {
  border-color: #ffffff;
}

body:not(.light_theme) .agce-margin-ordty-option-title {
  color: #ffffff;
}

body:not(.light_theme) .agce-margin-ordty-option-desc {
  color: #94a3b8;
}

body:not(.light_theme) .agce-margin-ordty-btn-confirm {
  background: #ffffff;
  color: #111214;
}

body:not(.light_theme) .agce-margin-ordty-btn-confirm:hover {
  background: #e2e8f0;
}

/* ==========================================================================
   AGCX Custom Filter Select Styles (Replaces default select dropdown popup)
   ========================================================================== */

.agce-custom-select-container {
  position: relative;
  width: auto;
  min-width: 95px;
  display: inline-block;
  margin-right: 6px;
  margin-bottom: 0;
  vertical-align: middle;
}

.agce-custom-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 30px;
  padding: 0 10px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 4px;
  color: #eaecef;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;
  transition: border-color 0.2s, background-color 0.2s;
  gap: 8px;
}

body.light_theme .agce-custom-select-trigger {
  background: #f6f6f7;
  border: 1px solid #cbd5e1;
  color: #1e2329;
}

/* .agce-custom-select-trigger:focus,
.agce-custom-select-trigger:hover {
  border-color: #d1aa67;
} */

.agce-custom-select-trigger i {
  font-size: 14px;
  transition: transform 0.2s ease;
  color: #848e9c;
}

.agce-custom-select-trigger i.open {
  transform: rotate(180deg);
}

.agce-custom-select-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  width: max-content;
  max-width: 200px;
  max-height: 220px;
  overflow-y: auto;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 6px;
  z-index: 100000;
  padding: 4px 0;
  margin: 0;
  list-style: none;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
}

body.light_theme .agce-custom-select-options {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
}

.agce-custom-select-option {
  padding: 8px 14px;
  font-size: 12px;
  color: #eaecef;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s, color 0.15s;
  white-space: nowrap;
}

body.light_theme .agce-custom-select-option {
  color: #1e2329;
}

.agce-custom-select-option:hover {
  background: #2b3139;
  color: #d1aa67;
}

body.light_theme .agce-custom-select-option:hover {
  background: #f1f5f9;
  color: #d1aa67;
}

.agce-custom-select-option.selected {
  background: rgba(209, 170, 103, 0.15);
  color: #d1aa67;
  font-weight: 600;
}

body.light_theme .agce-custom-select-option.selected {
  background: rgba(209, 170, 103, 0.1);
  color: #d1aa67;
  font-weight: 600;
}

/* Scrollbar customization for custom dropdown list */
.agce-custom-select-options::-webkit-scrollbar {
  width: 4px;
}

.agce-custom-select-options::-webkit-scrollbar-track {
  background: transparent;
}

.agce-custom-select-options::-webkit-scrollbar-thumb {
  background: #474f59;
  border-radius: 4px;
}

.agce-margin-level-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.agce-margin-level-value {
  font-weight: 600;
}

.agce-margin-level--safe,
.agce-margin-level--normal {
  color: #16a34a !important;
}

.agce-margin-level--margin_call {
  color: #d97706 !important;
}

.agce-margin-level--liquidated {
  color: #dc2626 !important;
}

.agce-margin-level--unavailable {
  color: #9ca3af !important;
}

.agce-margin-level-indicator--wallet {
  margin-top: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1.3;
}

.agce-margin-level-wallet--safe,
.agce-margin-level-wallet--normal {
  background: rgba(22, 163, 74, 0.12);
}

.agce-margin-level-wallet--margin_call {
  background: rgba(217, 119, 6, 0.14);
}

.agce-margin-level-wallet--liquidated {
  background: rgba(220, 38, 38, 0.12);
}

.agce-margin-level-wallet--unavailable {
  background: rgba(156, 163, 175, 0.12);
}

body.light_theme .agce-margin-level-wallet--safe,
body.light_theme .agce-margin-level-wallet--normal {
  background: #e8f5e9;
}

body.light_theme .agce-margin-level-wallet--margin_call {
  background: #fff7ed;
}

body.light_theme .agce-margin-level-wallet--liquidated {
  background: #fef2f2;
}

body.light_theme .agce-margin-level-wallet--unavailable {
  background: #f3f4f6;
}

.margin-pro-page .funding-account__pair .agce-margin-level-value {
  font-size: 11px;
  font-weight: 600;
}

.spot_orders_table .agce-margin-level-indicator--wallet,
.active-position-detail-value .agce-margin-level-indicator--wallet {
  margin-top: 0;
}

.spot_orders_table .agce-margin-level-indicator--wallet .agce-margin-level-value,
.active-position-detail-value .agce-margin-level-indicator--wallet .agce-margin-level-value {
  font-size: 12px;
}

.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--normal,
.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--safe,
.active-position-detail-value .agce-margin-level-value.agce-margin-level--normal,
.active-position-detail-value .agce-margin-level-value.agce-margin-level--safe {
  color: #01bc8d !important;
}

.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--margin_call,
.active-position-detail-value .agce-margin-level-value.agce-margin-level--margin_call {
  color: #d97706 !important;
}

.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--liquidated,
.active-position-detail-value .agce-margin-level-value.agce-margin-level--liquidated {
  color: #dc2626 !important;
}

.margin-modal-container .margin-info-row .agce-margin-level-indicator {
  justify-content: flex-end;
}

.agce-margin-level-info {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.agce-margin-level-info-icon {
  font-size: 12px;
  color: #9ca3af;
  cursor: pointer !important;
}

.agce-margin-level-tooltip {
  min-width: 220px;
  max-width: 280px;
  white-space: normal;
}

.agce-margin-level-tooltip-value {
  color: #9ca3af;
  font-weight: 500;
}

body.light_theme .agce-margin-level-tooltip-value {
  color: #6b7280;
}

.agce-margin-level-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent !important;
  line-height: 1;
  cursor: pointer !important;
}

.agce-margin-level-info-btn:focus-visible {
  outline: 2px solid #d0aa67;
  outline-offset: 2px;
  border-radius: 4px;
}

/* Isolated Margin Risk modal */
.agce-margin-risk-modal__dialog {
  max-width: 440px !important;
  margin: 1rem auto !important;
}

.agce-margin-risk-modal__content {
  --agce-mr-text: #eaecef;
  --agce-mr-muted: #848e9c;
  --agce-mr-border: rgba(255, 255, 255, 0.08);
  --agce-mr-surface: #1e2329;
  --agce-mr-pill-safe-bg: rgba(22, 163, 74, 0.15);
  --agce-mr-pill-safe-text: #4ade80;
  --agce-mr-pill-normal-bg: rgba(22, 163, 74, 0.15);
  --agce-mr-pill-normal-text: #4ade80;
  --agce-mr-pill-call-bg: rgba(245, 158, 11, 0.18);
  --agce-mr-pill-call-text: #fbbf24;
  --agce-mr-pill-liq-bg: rgba(220, 38, 38, 0.18);
  --agce-mr-pill-liq-text: #f87171;
  --agce-mr-zone-danger: #ef4444;
  --agce-mr-zone-warning: #f59e0b;
  --agce-mr-zone-normal: #22c55e;
  --agce-mr-active-bg: rgba(255, 255, 255, 0.04);

  width: 100% !important;
  max-width: 100% !important;
  border-radius: 16px !important;
  border: 1px solid var(--agce-mr-border) !important;
  background: var(--agce-mr-surface) !important;
  color: var(--agce-mr-text) !important;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.35) !important;
  max-height: calc(100vh - 2rem);
  overflow: hidden;
}

body.light_theme .agce-margin-risk-modal__content {
  --agce-mr-text: #1e2329;
  --agce-mr-muted: #707a8a;
  --agce-mr-border: #eef0f2;
  --agce-mr-surface: #ffffff;
  --agce-mr-pill-safe-bg: #ecfdf5;
  --agce-mr-pill-safe-text: #15803d;
  --agce-mr-pill-normal-bg: #ecfdf5;
  --agce-mr-pill-normal-text: #15803d;
  --agce-mr-pill-call-bg: #fff7ed;
  --agce-mr-pill-call-text: #c2410c;
  --agce-mr-pill-liq-bg: #fef2f2;
  --agce-mr-pill-liq-text: #b91c1c;
  --agce-mr-active-bg: #f9fafb;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12) !important;
}

.agce-margin-risk-modal__close {
  margin: 0 !important;
  flex-shrink: 0;
  opacity: 0.7;
  filter: invert(1) grayscale(100%);
}

body.light_theme .agce-margin-risk-modal__close {
  filter: none;
}

.agce-margin-risk-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 20px 0 !important;
  border: none !important;
}

.agce-margin-risk-modal__title {
  margin: 0 0 6px;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.25;
  color: var(--agce-mr-text);
}

.agce-margin-risk-modal__subtitle {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--agce-mr-muted);
}

.agce-margin-risk-modal__body {
  padding: 16px 20px 20px !important;
}

.agce-margin-risk-hero {
  margin-bottom: 18px;
}

.agce-margin-risk-hero__top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 12px;
  margin-bottom: 8px;
}

.agce-margin-risk-hero__value {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--agce-mr-text);
}

.agce-margin-risk-hero__value--safe {
  color: var(--agce-mr-pill-safe-text);
}

.agce-margin-risk-hero__pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
}

.agce-margin-risk-hero__pill--safe,
.agce-margin-risk-hero__pill--normal {
  background: var(--agce-mr-pill-normal-bg);
  color: var(--agce-mr-pill-normal-text);
}

.agce-margin-risk-hero__pill--margin_call {
  background: var(--agce-mr-pill-call-bg);
  color: var(--agce-mr-pill-call-text);
}

.agce-margin-risk-hero__pill--liquidated {
  background: var(--agce-mr-pill-liq-bg);
  color: var(--agce-mr-pill-liq-text);
}

.agce-margin-risk-hero__pill--unavailable {
  background: rgba(156, 163, 175, 0.15);
  color: var(--agce-mr-muted);
}

.agce-margin-risk-hero__formula {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.45;
  color: var(--agce-mr-muted);
}

.agce-margin-risk-meter {
  margin-bottom: 20px;
}

.agce-margin-risk-meter__track {
  position: relative;
  display: flex;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--agce-mr-border);
}

.agce-margin-risk-meter__zone {
  height: 100%;
  flex-shrink: 0;
}

.agce-margin-risk-meter__zone--danger {
  background: var(--agce-mr-zone-danger);
}

.agce-margin-risk-meter__zone--warning {
  background: var(--agce-mr-zone-warning);
}

.agce-margin-risk-meter__zone--normal {
  flex: 1 1;
  background: var(--agce-mr-zone-normal);
}

.agce-margin-risk-meter__marker {
  position: absolute;
  top: -3px;
  width: 2px;
  height: 14px;
  margin-left: -1px;
  background: var(--agce-mr-text);
  border-radius: 1px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.agce-margin-risk-meter__labels {
  position: relative;
  height: 18px;
  margin-top: 6px;
}

.agce-margin-risk-meter__label {
  position: absolute;
  transform: translateX(-50%);
  font-size: 0.6875rem;
  color: var(--agce-mr-muted);
  white-space: nowrap;
}

.agce-margin-risk-tier-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 16px;
}

.agce-margin-risk-tier {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 10px 12px;
  border-radius: 10px;
}

.agce-margin-risk-tier--active {
  background: var(--agce-mr-active-bg);
}

.agce-margin-risk-tier__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
}

.agce-margin-risk-tier__dot--normal {
  background: #22c55e;
}

.agce-margin-risk-tier__dot--warning {
  background: #f59e0b;
}

.agce-margin-risk-tier__dot--danger {
  background: #ef4444;
}

.agce-margin-risk-tier__content {
  min-width: 0;
}

.agce-margin-risk-tier__title {
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--agce-mr-text);
  margin-bottom: 2px;
}

.agce-margin-risk-tier__subtitle {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.45;
  color: var(--agce-mr-muted);
}

.agce-margin-risk-modal__footnote,
.agce-margin-risk-modal__loading {
  margin: 0 0 16px;
  padding-top: 14px;
  border-top: 1px solid var(--agce-mr-border);
  font-size: 0.75rem;
  line-height: 1.45;
  color: var(--agce-mr-muted);
}

.agce-margin-risk-modal__sections {
  border-top: 1px solid var(--agce-mr-border);
}

.agce-margin-risk-section {
  border-bottom: 1px solid var(--agce-mr-border);
}

.agce-margin-risk-section:last-child {
  border-bottom: none;
}

.agce-margin-risk-section__header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  border: none;
  background: transparent;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--agce-mr-text);
  cursor: pointer;
  text-align: left;
}

.agce-margin-risk-section__header i {
  font-size: 1rem;
  color: var(--agce-mr-muted);
  flex-shrink: 0;
}

.agce-margin-risk-section__body {
  padding: 0 0 14px;
}

.agce-margin-risk-section__desc {
  margin: 0 0 10px;
  font-size: 0.75rem;
  line-height: 1.45;
  color: var(--agce-mr-muted);
}

.agce-margin-risk-rules {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agce-margin-risk-rule {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 8px 10px;
  font-size: 0.8125rem;
}

.agce-margin-risk-rule__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--agce-mr-muted);
  flex-shrink: 0;
}

.agce-margin-risk-rule__dot--ok {
  background: #22c55e;
}

.agce-margin-risk-rule__label {
  color: var(--agce-mr-text);
  font-weight: 500;
}

.agce-margin-risk-rule__value {
  color: var(--agce-mr-muted);
  text-align: right;
  font-size: 0.75rem;
}

@media (max-width: 575.98px) {
  .agce-margin-risk-modal__dialog {
    max-width: calc(100% - 1rem) !important;
    margin: 0.5rem auto !important;
  }

  .agce-margin-risk-modal__content {
    border-radius: 14px !important;
    max-height: calc(100vh - 1rem);
  }

  .agce-margin-risk-modal__header {
    padding: 16px 16px 0 !important;
  }

  .agce-margin-risk-modal__body {
    padding: 14px 16px 16px !important;
  }

  .agce-margin-risk-hero__value {
    font-size: 1.75rem;
  }

  .agce-margin-risk-rule {
    grid-template-columns: auto 1fr;
  }

  .agce-margin-risk-rule__value {
    grid-column: 2;
    text-align: left;
  }
}

body.light_theme .agce-custom-select-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
}

/* Mobile popup filter content adjustments */
.agce-margin-filter-popup-content .agce-custom-select-container {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 12px;
}

.agce-margin-filter-popup-content .agce-custom-select-trigger {
  height: 38px;
  font-size: 13px;
  padding: 0 12px;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/margin/margin.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAElF;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,+BAA+B;;AAE/B;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA,yFAAyF;AACzF;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA,8FAA8F;AAC9F;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4FAA4F;AAC5F;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uGAAuG;AACvG;;;;;;;EAOE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;EAcE,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;;;;AAKA;;kFAEkF;AAClF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;;;AAIA;;EAEE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;AAEF;;AAEA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oDAAoD;AACpD;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,kDAAkD;EAClD,oBAAoB;EACpB,QAAQ;AACV;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;AACb;;;;AAIA,0DAA0D;AAC1D;;EAEE,gDAAgD;EAChD;IACE,2BAA2B;IAC3B,oBAAoB;IACpB,YAAY;EACd;;;EAGA;IACE,eAAe;EACjB;;EAEA,mFAAmF;EACnF;IACE,qCAAqC;EACvC;;EAEA,kEAAkE;EAClE;;IAEE,gDAAgD;IAChD,6CAA6C;IAC7C,2BAA2B;EAC7B;;EAEA,iFAAiF;EACjF;;IAEE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,8DAA8D;EAC9D;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;IACZ,4CAA4C;EAC9C;;EAEA,kEAAkE;EAClE;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;AAEF;;;AAGA;;;EAGE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+CAE+C;AAC/C;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,oDAAoD;EACpD,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2CAA2C;EAC3C,0BAA0B;EAC1B,+CAA+C;EAC/C,iCAAiC;EACjC,iDAAiD;EACjD,mCAAmC;EACnC,gDAAgD;EAChD,iCAAiC;EACjC,8CAA8C;EAC9C,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,8CAA8C;;EAE9C,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,kDAAkD;EAClD,6CAA6C;EAC7C,qCAAqC;EACrC,sDAAsD;EACtD,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,uCAAuC;IACvC,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* =============================================================================\n   Margin trading page — leverage trigger + Adjust Leverage modal\n   (Loaded from margin/index.js; scoped with .agce-margin- prefix.)\n   ============================================================================= */\n\n.agce-margin-leverage-row {\n  padding: 4px 10px 8px;\n}\n\n.pnl-green {\n  color: #008000 !important;\n}\n\n.pnl-danger {\n  color: #ff0000 !important;\n}\n\n.agce-margin-leverage-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: inherit;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n}\n\n.agce-margin-leverage-trigger:hover {\n  opacity: 0.8;\n}\n\n\n.agce-margin-leverage-label {\n  color: #94a3b8;\n  font-weight: 500;\n}\n\nbody.light_theme .agce-margin-leverage-label {\n  color: #64748b;\n}\n\n.agce-margin-leverage-value {\n  color: #e2e8f0;\n  font-weight: 600;\n}\n\nbody.light_theme .agce-margin-leverage-value {\n  color: #0f172a;\n}\n\n/* --- NO-DATA CENTERING --- */\n.spot_orders_no_data_row {\n  width: 100% !important;\n  display: table-row !important;\n}\n\n.spot_orders_no_data_row td {\n  width: 100% !important;\n  display: table-cell !important;\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0 !important;\n}\n\n.spot_orders_empty_state {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  text-align: center !important;\n  width: 100% !important;\n  /* min-height: 600px !important; */\n  padding: 48px 0 !important;\n}\n\n.spot_orders_empty_telescope {\n  display: block !important;\n  margin: 0 auto !important;\n}\n\n/* -------------------------- */\n\n.agce-margin-leverage-trigger i {\n  font-size: 18px;\n  opacity: 0.85;\n  margin-left: 2px;\n}\n\n/* Spot / Cross / Isolated / ETF / Futures — single row + horizontal scroll when narrow */\n.agce-margin-surface-tabs-outer {\n  min-width: 0;\n}\n\n.agce-margin-surface-tabs-scroll-wrap {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.agce-margin-surface-tabs-scroller {\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.agce-margin-surface-tabs-scroller::-webkit-scrollbar {\n  display: none;\n}\n\n.margin-surface-tabs .margin_surface_tab_strip>button {\n  flex-shrink: 0;\n}\n\n.agce-margin-surface-tab-scroll-btn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: color 0.15s ease, background 0.15s ease, opacity 0.15s ease;\n}\n\n.agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.agce-margin-surface-tab-scroll-btn:disabled {\n  opacity: 0.28;\n  cursor: default;\n  pointer-events: none;\n}\n\nbody.light_theme .agce-margin-surface-tab-scroll-btn {\n  color: #84888c;\n}\n\nbody.light_theme .agce-margin-surface-tab-scroll-btn:hover:not(:disabled) {\n  color: #0f172a;\n  background: rgba(15, 23, 42, 0.06);\n}\n\n/* ——— Modal ——— */\n.agce-margin-lvg-modal-root {\n  position: fixed;\n  inset: 0;\n  z-index: 10600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  z-index: 99999999;\n}\n\n.agce-margin-lvg-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n}\n\n.agce-margin-lvg-modal-panel {\n  position: relative;\n  width: 100%;\n  max-width: 540px;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);\n  font-family: \"Inter\", sans-serif;\n  overflow: hidden;\n}\n\n.agce-margin-lvg-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 18px 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.agce-margin-lvg-modal-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.agce-margin-lvg-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.agce-margin-lvg-modal-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-margin-lvg-modal-body {\n  padding: 16px 18px 8px;\n}\n\n.agce-margin-lvg-field-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n\n.agce-margin-lvg-coin-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 18px;\n}\n\n.agce-margin-lvg-coin-row img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.agce-margin-lvg-input-wrap {\n  position: relative;\n  margin-bottom: 12px;\n}\n\n.agce-margin-lvg-input {\n  width: 100%;\n  padding: 12px 40px 12px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  outline: none;\n}\n\n.agce-margin-lvg-input:focus {\n  border-color: #0f172a;\n  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.08);\n}\n\n.agce-margin-lvg-stepper {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.agce-margin-lvg-stepper button {\n  width: 22px;\n  height: 12px;\n  border: none;\n  background: none;\n  border-radius: 4px;\n  font-size: 10px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n}\n\n/* .agce-margin-lvg-stepper button:hover {\n  background: #e2e8f0;\n} */\n\n.agce-margin-lvg-quick {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 18px;\n}\n\n.agce-margin-lvg-quick button {\n  min-width: 52px;\n  padding: 8px 6px;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n}\n\n.agce-margin-lvg-quick button:hover {\n  background: #e2e8f0;\n}\n\n.agce-margin-lvg-quick button.is-active {\n  border-color: #0f172a;\n  background: #fff;\n  color: #0f172a;\n}\n\n.agce-margin-lvg-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.agce-margin-lvg-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n}\n\n.agce-margin-lvg-stat dt {\n  margin: 0;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.agce-margin-lvg-stat dd {\n  margin: 0;\n  font-weight: 600;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.agce-margin-lvg-warn {\n  font-size: 12px;\n  line-height: 1.45;\n  color: #ea580c;\n  margin: 0 0 8px;\n}\n\n.agce-margin-lvg-modal-foot {\n  display: flex;\n  gap: 10px;\n  padding: 14px 18px 18px;\n}\n\n.agce-margin-lvg-btn {\n  flex: 1;\n  padding: 12px 14px;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n}\n\n.agce-margin-lvg-btn--ghost {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-margin-lvg-btn--ghost:hover {\n  background: #e2e8f0;\n}\n\n.agce-margin-lvg-btn--primary {\n  background: #0f172a;\n  color: #fff;\n}\n\n.agce-margin-lvg-btn--primary:hover {\n  background: #1e293b;\n}\n\n/* ——— Advanced Limit — Order Type modal ——— */\n.agce-margin-ordty-modal-root {\n  position: fixed;\n  inset: 0;\n  z-index: 9999999999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n}\n\n.agce-margin-ordty-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n}\n\n.agce-margin-ordty-modal-panel {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  max-height: min(92vh, 640px);\n  display: flex;\n  flex-direction: column;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);\n  font-family: \"Inter\", sans-serif;\n  overflow: hidden;\n}\n\n.agce-margin-ordty-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  padding: 16px 18px 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.agce-margin-ordty-modal-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.agce-margin-ordty-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.agce-margin-ordty-modal-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-margin-ordty-modal-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 14px 18px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agce-margin-ordty-option {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  width: 100%;\n  margin: 0;\n  padding: 12px 14px;\n  text-align: left;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.agce-margin-ordty-option:hover {\n  border-color: #cbd5e1;\n}\n\n.agce-margin-ordty-option.is-selected {\n  border-width: 1px;\n  border-color: #c6c6c6;\n  padding: 11px 13px;\n  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.06);\n}\n\n.agce-margin-ordty-option-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.agce-margin-ordty-option-desc {\n  font-size: 13px;\n  line-height: 1.45;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.agce-margin-ordty-modal-foot {\n  flex-shrink: 0;\n  padding: 14px 18px 18px;\n}\n\n.agce-margin-ordty-btn-confirm {\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 10px;\n  border: none;\n  background: #0f172a;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: \"Inter\", sans-serif;\n  cursor: pointer;\n}\n\n.agce-margin-ordty-btn-confirm:hover {\n  background: #1e293b;\n}\n\n\n\n/* TP/SL — one Market/Limit toggle; same fill + radius as .trade_price_field (trade_new.css) */\n.agce-margin-tp-sl-price-row {\n  flex-wrap: nowrap;\n}\n\n.agce-margin-tp-sl-toggle-btn {\n  flex-shrink: 0;\n  align-self: stretch;\n  min-width: 72px;\n  height: 40px;\n  margin: 0;\n  padding: 0 14px;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 8px;\n  background: #f6f6f7;\n  color: #070808;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.agce-margin-tp-sl-toggle-btn:hover {\n  background: #ececed;\n}\n\n.agce-margin-tp-sl-toggle-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);\n}\n\nbody.light_theme .agce-margin-tp-sl-toggle-btn {\n  background: #f6f6f7;\n  color: #070808;\n}\n\nbody.light_theme .agce-margin-tp-sl-toggle-btn:hover {\n  background: #ececed;\n}\n\n/* Conditional — Order Price: strong border when execution is Market (matches mobile ref). */\n.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed=\"false\"] {\n  background: #f5f5f5;\n  font-weight: 500;\n}\n\n.margin-advanced-block--cond .agce-margin-tp-sl-toggle-btn[aria-pressed=\"true\"] {\n  border: 1px solid #e2e8f0;\n}\n\n/* TP/SL + TWAP + Iceberg — extra breathing room for quote/base suffix (USDT, BTC) inside filled rows */\n.margin-advanced-block--tp-sl .trade_price_suffix,\n.margin-advanced-block--twap .trade_price_suffix,\n.margin-advanced-block--iceberg .trade_price_suffix,\n.margin-advanced-block--loop .trade_price_suffix,\n.margin-advanced-block--trail .trade_price_suffix,\n.margin-advanced-block--adv-lim .trade_price_suffix,\n.margin-advanced-block--cond .trade_price_suffix {\n  padding-left: 10px;\n  padding-right: 14px;\n}\n\n.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--tp-sl .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--twap .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--iceberg .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--loop .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--trail .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--adv-lim .trade_amount_field_limit>.input-group-text,\n.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text.trade_amount_coin_badge,\n.margin-advanced-block--cond .trade_amount_field_limit>.input-group-text {\n  padding-left: 10px !important;\n  padding-right: 14px !important;\n  min-width: 3.25rem;\n  justify-content: center;\n}\n\n/* Loop Order — price row (optional + quote | mode), Valid for row, dropdown menus */\n.trade_price_field.agce-margin-loop-price-row {\n  position: relative;\n  align-items: center;\n  padding-right: 4px;\n}\n\n.agce-margin-loop-price-quote {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  padding-right: 2px;\n}\n\n.agce-margin-loop-price-bar {\n  flex-shrink: 0;\n  padding: 0 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #c3c6c8;\n  user-select: none;\n}\n\n.agce-margin-loop-price-mode {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: stretch;\n  align-self: stretch;\n  margin-left: 4px;\n  padding-left: 6px;\n  border-left: 1px solid #dfe0e2;\n}\n\n.agce-margin-loop-price-mode-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  padding: 0 8px 0 4px;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  cursor: pointer;\n  white-space: nowrap;\n  outline: none;\n}\n\n.agce-margin-loop-price-mode-btn:focus-visible {\n  box-shadow: none;\n}\n\n.agce-margin-loop-price-mode-chev {\n  font-size: 18px;\n  color: #64748b;\n  line-height: 1;\n  margin-left: 2px;\n}\n\n.agce-margin-loop-price-row.is-open .agce-margin-loop-price-mode-chev,\n.agce-margin-loop-valid-wrap.is-open .agce-margin-loop-valid-chev {\n  color: #475569;\n}\n\n.trade_price_field.agce-margin-loop-valid-wrap {\n  position: relative;\n  padding: 0;\n}\n\n.agce-margin-loop-valid-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 40px;\n  margin: 0;\n  padding: 0 12px 0 12px;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #070808;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n}\n\n.agce-margin-loop-valid-btn:focus-visible {\n  box-shadow: none;\n}\n\n.agce-margin-loop-valid-btn__text {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.agce-margin-loop-valid-chev {\n  font-size: 18px;\n  color: #64748b;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.agce-margin-loop-price-mode .agce-margin-loop-pick__menu {\n  left: auto;\n  right: 0;\n  min-width: 11rem;\n}\n\n.agce-margin-loop-valid-wrap .agce-margin-loop-pick__menu {\n  left: 0;\n  right: 0;\n}\n\n.agce-margin-loop-pick__menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  z-index: 30;\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.agce-margin-loop-pick__menu-item {\n  margin: 0;\n  padding: 0;\n}\n\n.agce-margin-loop-pick__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  margin: 0;\n  padding: 5px 14px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.agce-margin-loop-pick__option:hover {\n  background: #f1f5f9;\n}\n\n.agce-margin-loop-pick__check {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: #1e90ff;\n  line-height: 1;\n}\n\n.agce-margin-loop-pick__check-slot {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n}\n\n/* Trailing Stop — pullback: filled row + %|USDT unit menu + 5% chip */\n.agce-margin-trail-pullback-row {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.agce-margin-trail-pullback-field.trade_price_field {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.agce-margin-trail-preset-chip {\n  flex-shrink: 0;\n  min-width: 52px;\n  margin: 0;\n  padding: 0 12px;\n  box-sizing: border-box;\n  height: 40px;\n  align-self: stretch;\n  border: none;\n  border-radius: 8px;\n  background: #f6f6f7;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #070808;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.agce-margin-trail-preset-chip:hover {\n  background: #ececed;\n}\n\n.agce-margin-trail-preset-chip:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 1px rgba(30, 144, 255, 0.45);\n}\n\n.agce-margin-twap-interval-unit-wrap.agce-margin-trail-pull-unit .agce-margin-loop-pick__menu {\n  left: auto;\n  right: 0;\n  min-width: 8rem;\n}\n\n.agce-margin-iceberg-section-title {\n  margin: 0 0 10px 2px;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #1f1f1f;\n}\n\n/* TWAP — duration split (H | M), presets, advanced toggle, inline selects */\n.agce-margin-twap-duration-shell {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: nowrap;\n  width: 100%;\n  min-height: 40px;\n  box-sizing: border-box;\n  background: #f6f6f7;\n  border-radius: 8px;\n  overflow: hidden;\n  font-family: \"Inter\", sans-serif;\n}\n\n.agce-margin-twap-duration-cell {\n  flex: 1 1 50%;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  padding: 0 4px 0 12px;\n}\n\n.agce-margin-twap-duration-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #070808;\n  padding: 0 6px 0 0;\n  line-height: 1.25;\n}\n\n.agce-margin-twap-duration-input::placeholder {\n  color: #c3c6c8;\n  font-weight: 500;\n}\n\n.agce-margin-twap-duration-suffix {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  padding-right: 10px;\n}\n\n.agce-margin-twap-duration-divider {\n  width: 1px;\n  flex-shrink: 0;\n  background: #dfe0e2;\n  align-self: stretch;\n  margin: 6px 0;\n}\n\n.agce-margin-twap-preset-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.agce-margin-twap-preset {\n  flex: 1 1 calc(25% - 8px);\n  min-width: 56px;\n  height: 36px;\n  margin: 0;\n  padding: 0 8px;\n  border: none;\n  border-radius: 8px;\n  background: #f0f1f3;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: \"Inter\", sans-serif;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.agce-margin-twap-preset:hover {\n  background: #e4e6ea;\n}\n\n.agce-margin-twap-advanced-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin: 0 0 0.25rem;\n  padding: 10px 4px 10px 2px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-family: \"Inter\", sans-serif;\n}\n\n.agce-margin-twap-advanced-toggle__label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.agce-margin-twap-advanced-toggle__icon {\n  font-size: 20px;\n  color: #64748b;\n  line-height: 1;\n}\n\n.agce-margin-twap-advanced-panel {\n  padding-top: 2px;\n}\n\n/* TWAP advanced — click-to-open value lists + chevron affordance */\n.agce-margin-twap-pick-field {\n  position: relative;\n}\n\n.agce-margin-twap-per-pick {\n  position: relative;\n}\n\nbutton.agce-margin-twap-pick-rowbtn {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  width: 100%;\n  min-height: 38px;\n  margin: 0;\n  padding: 0 10px 0 2px;\n  box-sizing: border-box;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #070808;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n  gap: 6px;\n}\n\nbutton.agce-margin-twap-pick-rowbtn--muted {\n  color: #c3c6c8;\n}\n\nbutton.agce-margin-twap-pick-rowbtn--per {\n  min-height: calc(1.5em + 0.75rem + 2px);\n}\n\n.agce-margin-twap-pick-rowbtn__text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agce-margin-twap-pick-rowbtn__unit {\n  flex-shrink: 0;\n  padding-left: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #070808;\n}\n\n.agce-margin-twap-pick__chev {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: #64748b;\n  line-height: 1;\n  margin-left: 2px;\n}\n\n.agce-margin-twap-pick-field.is-open .agce-margin-twap-pick__chev,\n.agce-margin-twap-interval-row.is-open .agce-margin-twap-pick__chev,\n.agce-margin-twap-per-pick.is-open .agce-margin-twap-pick__chev {\n  color: #475569;\n}\n\n/* TWAP Time Interval — one filled row: value (Limit-style input) + Hour|Minute + chevron */\n.trade_price_field.agce-margin-twap-interval-row {\n  position: relative;\n}\n\n.agce-margin-twap-interval-unit-wrap {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: stretch;\n  align-self: stretch;\n  margin-left: 7px;\n  padding-left: 2px;\n  border-left: 1px solid #dfe0e2;\n}\n\n.agce-margin-twap-interval-unit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  padding: 0 10px 0 8px;\n  border: 0;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: #070808;\n  cursor: pointer;\n  white-space: nowrap;\n  outline: none;\n}\n\n.agce-margin-twap-interval-unit-btn:focus-visible {\n  box-shadow: none;\n}\n\n.agce-margin-twap-interval-unit-wrap .agce-margin-twap-pick__menu {\n  left: auto;\n  right: 0;\n  min-width: 8.5rem;\n}\n\n.agce-margin-twap-pick__menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 4px);\n  z-index: 30;\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.agce-margin-twap-pick__menu-item {\n  margin: 0;\n  padding: 0;\n}\n\n.agce-margin-twap-pick__option {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.agce-margin-twap-pick__option:hover {\n  background: #f1f5f9;\n}\n\n.agce-margin-twap-per-pick .agce-margin-twap-pick__menu {\n  left: 0;\n  right: 0;\n}\n\n.agce-margin-twap-est-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #475569;\n}\n\n.agce-margin-twap-est-label {\n  flex: 1 1 auto;\n  line-height: 1.35;\n  max-width: 58%;\n}\n\n.agce-margin-twap-est-val {\n  flex-shrink: 0;\n  font-weight: 600;\n  color: #070808;\n  text-align: right;\n}\n\n\n\n\n/* =============================================================================\n   Add Funds Modal (margin page)\n   ============================================================================= */\n.agcx-add-funds-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 2147483647;\n  background-color: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  animation: agcx-af-fade 160ms ease-out both;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-overlay {\n  background-color: rgb(0 0 0 / 50%);\n}\n\n.agcx-add-funds-modal {\n  width: min(760px, 100%);\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: agcx-af-pop 200ms ease-out both;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-modal {\n  background: #1e222d;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.agcx-add-funds-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n}\n\n.agcx-add-funds-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0e11;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-title {\n  color: #f8fafc;\n}\n\n.agcx-add-funds-close {\n  border: none;\n  background: transparent;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  color: #9aa0a6;\n  padding: 6px 10px;\n  border-radius: 10px;\n}\n\n.agcx-add-funds-close:hover {\n  color: #111827;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-close:hover {\n  color: #f8fafc;\n}\n\n.agcx-add-funds-body {\n  padding: 0px 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.agcx-add-funds-card {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 18px;\n  border-radius: 14px;\n  border: 1px solid #eef0f2;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: none;\n  color: inherit;\n  font: inherit;\n}\n\n.agcx-add-funds-card:hover {\n  border-color: #e5e7eb;\n  background: #fbfbfc;\n  text-decoration: none;\n  color: inherit;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-card {\n  border-color: #2a2e39;\n  background: #1e222d;\n  color: #f8fafc;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-card:hover {\n  border-color: #3a3e49;\n  background: #262a35;\n  color: #f8fafc;\n}\n\n.agcx-add-funds-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #111827;\n  font-size: 22px;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-icon {\n  background: #2a2e39;\n  color: #f8fafc;\n}\n\n.agcx-add-funds-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.agcx-add-funds-item-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-item-title {\n  color: #f8fafc;\n}\n\n.agcx-add-funds-desc {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8e9299;\n  line-height: 1.35;\n}\n\n.agcx-add-funds-sub {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8e9299;\n}\n\n.agcx-add-funds-more {\n  width: 100%;\n  border: none;\n  background: transparent;\n  color: #070707;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 10px 0 10px;\n  cursor: pointer;\n}\n\nhtml[data-theme=\"dark\"] .agcx-add-funds-more {\n  color: #070707\n}\n\n@keyframes agcx-af-fade {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes agcx-af-pop {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n\n\n@media (max-width: 767px) {\n\n  .agcx-add-funds-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .agce-margin-lvg-modal-root {\n    align-items: end;\n  }\n\n  .agcx-add-funds-modal {\n    border-radius: 14px 14px 0px 0px;\n  }\n\n  .agce-margin-lvg-modal-panel {\n    border-radius: 14px 14px 0px 0px;\n    max-width: 100%;\n  }\n\n  .agce-margin-ordty-modal-root {\n    align-items: end;\n  }\n\n\n  .agce-margin-ordty-modal-panel {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 14px 14px 0px 0px;\n  }\n\n}\n\n@media (max-width: 576px) {\n\n  .agcx-add-funds-head {\n    padding: 16px 18px;\n  }\n\n  .agcx-add-funds-body {\n    padding: 0px 18px 14px;\n    gap: 10px;\n  }\n\n  .agcx-add-funds-card {\n    padding: 14px;\n    gap: 14px;\n  }\n\n  .agcx-add-funds-icon {\n    width: 38px;\n    height: 38px;\n    font-size: 18px;\n  }\n\n  .agcx-add-funds-item-title {\n    font-size: 15px;\n  }\n\n  .agcx-add-funds-desc {\n    font-size: 13px;\n  }\n}\n\n/* --- Percentage of Volume (POV) Order Fields --- */\n.agce-margin-pov-rates-container {\n  margin-top: 4px;\n}\n\n.agce-margin-pov-rate-btn {\n  font-size: 13px !important;\n  padding: 7px 8px !important;\n  border-radius: 4px;\n}\n\nspan.agce-margin-twap-advanced-toggle__label.text-dark.fw-bold.agce-margin-pov-adv-toggle-label {\n  font-weight: 500 !important;\n}\n\nbutton.agce-margin-pov-rate-btn:focus {\n  background-color: #f8f9fa !important;\n  border: 1px solid #000 !important;\n}\n\n.agce-margin-pov-valid-select {\n  height: 40px;\n}\n\n.agce-margin-pov-adv-toggle-label {\n  font-size: 14px;\n}\n\n.agce-margin-pov-adv-input-group {\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.agce-margin-pov-dotted-label {\n  text-decoration: underline;\n  text-decoration-style: dotted;\n}\n\n/* Order type tabs scroller styles */\n.agce-margin-order-tabs-outer {\n  position: relative;\n  overflow: visible !important;\n  flex-wrap: nowrap !important;\n}\n\n/* .agce-margin-order-tabs-scroller {\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none; \n} */\n\n.agce-margin-order-tabs-scroller::-webkit-scrollbar {\n  display: none;\n  /* Safari and Chrome */\n}\n\n.agce-margin-order-tabs-scroller .spot_limit {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap !important;\n}\n\n.agce-margin-order-tabs-scroller .spot_limit button,\n.agce-margin-order-tabs-scroller .spot_limit_dropdown {\n  flex-shrink: 0 !important;\n}\n\n.agce-margin-order-tab-scroll-btn-left,\n.agce-margin-order-tab-scroll-btn-right {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  z-index: 10;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #8E949E;\n}\n\n.agce-margin-order-tab-scroll-btn-left:disabled,\n.agce-margin-order-tab-scroll-btn-right:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n/* Futures Margin Balance Row Styles */\n.agce-futures-margin-dotted-label {\n  text-decoration: underline;\n  text-decoration-style: dotted;\n  text-underline-offset: 4px;\n  cursor: help;\n}\n\n.agce-futures-margin-value-container {\n  font-weight: 500;\n  font-family: \"Inter\", sans-serif;\n  display: flex;\n  align-items: center;\n}\n\n.agce-futures-margin-val-green {\n  color: #03c087 !important;\n  font-weight: 600;\n}\n\n.agce-futures-margin-divider {\n  color: #64748b;\n  margin: 0 4px;\n}\n\n.agce-futures-margin-val-red {\n  color: #ef4444 !important;\n  font-weight: 600;\n}\n\n.agce-futures-margin-currency {\n  font-weight: 500;\n  margin-left: 4px;\n}\n\nbody.light_theme .agce-futures-margin-divider {\n  color: #94a3b8;\n}\n\n/* Futures Points Card Styles */\n.agce-futures-points-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #edeff2;\n  border-radius: 8px;\n  padding: 10px 14px;\n  background: #ffffff;\n  text-decoration: none !important;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  width: 100%;\n}\n\n/* .agce-futures-points-card:hover {\n  background: #fbfbfc;\n  border-color: #e2e8f0;\n}\n\nbody.dark-mode .agce-futures-points-card,\nhtml[data-theme=\"dark\"] .agce-futures-points-card {\n  border-color: #2a2e39;\n  background: #1e222d;\n}\n\nbody.dark-mode .agce-futures-points-card:hover,\nhtml[data-theme=\"dark\"] .agce-futures-points-card:hover {\n  background: #262a35;\n  border-color: #3a3e49;\n} */\n\n.agce-futures-points-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.agce-futures-points-badge-icon {\n  width: 24px;\n  height: 24px;\n  background: #e6f9f3;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #00c087;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\nbody.dark-mode .agce-futures-points-badge-icon,\nhtml[data-theme=\"dark\"] .agce-futures-points-badge-icon {\n  background: rgba(0, 192, 135, 0.15);\n}\n\n.agce-futures-points-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  font-style: italic;\n  color: #00c087;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.agce-futures-points-spark {\n  font-size: 12px;\n  font-style: normal;\n}\n\n.agce-futures-points-right {\n  color: #94a3b8;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n/* Filter bar for margin trading history tables */\n.trade_summary_table_lft_position_order .agce-margin-filter-bar {\n  background: transparent !important;\n  flex-wrap: nowrap !important;\n  gap: 6px;\n  padding: 12px 0 5px;\n  align-items: center;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-filter-bar::-webkit-scrollbar {\n  display: none;\n  /* Safari and Chrome */\n}\n\n\n.trade_account_summary_assets .mobile_view2 {\n  display: none;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-filter-select {\n  flex-shrink: 0;\n  width: auto;\n  min-width: 90px;\n  max-width: 130px;\n  font-size: 12px;\n  padding: 3px 6px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-filter-btn {\n  flex-shrink: 0;\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  background: #f6f6f7;\n  border: 1px solid #f6f6f7;\n  font-weight: 400;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-filter-btn.active {\n  border: 1px solid #d1d5db;\n  font-weight: 600;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-filter-input {\n  width: 130px;\n  font-size: 12px;\n  padding: 6px 6px;\n  border-radius: 4px;\n  border: 1px solid #f6f6f712;\n  color: #959595;\n  background: #f6f6f714;\n  color-scheme: dark;\n}\n\n.agce-margin-date-input-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.agce-margin-date-input-wrap[data-empty=\"true\"]::before {\n  content: attr(data-placeholder);\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #959595;\n  font-size: 12px;\n  pointer-events: none;\n  z-index: 1;\n}\n\nbody.light_theme .agce-margin-date-input-wrap[data-empty=\"true\"]::before {\n  color: #6b7280;\n}\n\n.agce-margin-date-input-wrap[data-empty=\"true\"] .agce-margin-filter-input::-webkit-datetime-edit-text,\n.agce-margin-date-input-wrap[data-empty=\"true\"] .agce-margin-filter-input::-webkit-datetime-edit-month-field,\n.agce-margin-date-input-wrap[data-empty=\"true\"] .agce-margin-filter-input::-webkit-datetime-edit-day-field,\n.agce-margin-date-input-wrap[data-empty=\"true\"] .agce-margin-filter-input::-webkit-datetime-edit-year-field {\n  color: transparent !important;\n}\n\n\n.trade_summary_table_lft_position_order .agce-margin-filter-arrow {\n  font-size: 12px;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-filter-reset {\n  flex-shrink: 0;\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 4px;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n/* Subtabs layout for margin trading history tables */\n.trade_summary_table_lft_position_order .agce-margin-subtabs {\n  display: flex;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  margin: 12px 0px 6px;\n  gap: 8px;\n}\n\n/* body.light_theme .trade_summary_table_lft_position_order .agce-margin-subtabs {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n} */\n\n.trade_summary_table_lft_position_order .agce-margin-subtab-btn {\n  background: #F6F6F7;\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 400;\n  border-bottom: 2px solid transparent;\n  /* margin-bottom: -1px; */\n  color: #8E949E;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-subtab-btn:hover {\n  color: #fff;\n}\n\n.trade_summary_table_lft_position_order .agce-margin-subtab-btn.active {\n  font-weight: 600;\n  color: #fff;\n}\n\nbody.light_theme .trade_summary_table_lft_position_order .agce-margin-subtab-btn {\n  color: #4b5563;\n}\n\nbody.light_theme .trade_summary_table_lft_position_order .agce-margin-subtab-btn:hover {\n  color: #111827;\n}\n\nbody.light_theme .trade_summary_table_lft_position_order .agce-margin-filter-input {\n  border: 1px solid #f6f6f7;\n  color: #111827;\n  background: #f6f6f7;\n  color-scheme: light;\n}\n\nbody.light_theme .trade_summary_table_lft_position_order .agce-margin-filter-input::-webkit-calendar-picker-indicator {\n  filter: none;\n}\n\nbutton.agce-margin-surface-tab-scroll-btn.ms-1.flex-shrink-0:hover {\n  background: none !important;\n}\n\nbody.light_theme .trade_summary_table_lft_position_order .agce-margin-subtab-btn.active {\n  color: #111827;\n}\n\nspan.input-group-text.text-start.stop_amt_suffix.trade_amount_coin_badge {\n  display: flex !important;\n  justify-content: end;\n  color: #000;\n}\n\n\n\n/* Sticky top header for trade account summary on mobile */\n@media (max-width: 991.98px) {\n\n  /* Container sticks to the window at 80px down */\n  .trade_account_summary_assets {\n    position: sticky !important;\n    top: 80px !important;\n    z-index: 100;\n  }\n\n\n  .agce-margin-pos-val-primary {\n    font-size: 12px;\n  }\n\n  /* When the container is stuck at the top, it takes the remaining viewport height */\n  .trade_account_summary_assets.is-stuck {\n    height: calc(100vh - 80px) !important;\n  }\n\n  /* When stuck, the table container becomes internally scrollable */\n  .trade_account_summary_assets.is-stuck .mobile_view2,\n  .trade_account_summary_assets.is-stuck .order_history_mobile_view {\n    max-height: calc(100vh - 80px - 55px) !important;\n    /* 55px accounts for the sticky tabs header */\n    overflow-y: auto !important;\n  }\n\n  /* When NOT stuck, everything displays fully and scrolls natively with the page */\n  .trade_account_summary_assets:not(.is-stuck) .mobile_view2,\n  .trade_account_summary_assets:not(.is-stuck) .order_history_mobile_view {\n    max-height: none !important;\n    overflow-y: visible !important;\n  }\n\n  .trade_account_summary_assets .mobile_view2 {\n    padding-bottom: 90px;\n  }\n\n  .trade_summary_table_lft_position_order.position_order {\n    overflow: visible !important;\n  }\n\n  /* Header sticks to the top of the internal scroll container */\n  .trade_account_summary_assets .spot_orders_top {\n    position: sticky !important;\n    top: 0 !important;\n    z-index: 999;\n    box-shadow: 0 0px 1px 0px rgba(0, 0, 0, 0.1);\n  }\n\n  /* Force a solid background so scrolling rows don't show through */\n  body.light_theme .trade_account_summary_assets .spot_orders_top {\n    background: #ffffff !important;\n  }\n\n  .trade_account_summary_assets .mobile_view2 {\n    max-height: none !important;\n  }\n}\n\n/* Mobile Filter Popup Classes */\n.spot_orders_filter_bar.agce-margin-filter-bar {\n  flex-wrap: wrap;\n  overflow-x: visible;\n}\n\n.agce-margin-filter-toggle-btn {\n  border-radius: 6px;\n  font-size: 13px;\n  background: transparent;\n  border: 1px solid #4a4a4a;\n  color: inherit;\n}\n\n.agce-filter-overlay-active {\n  display: flex !important;\n  z-index: 99999999;\n}\n\n.agce-margin-filter-popup .agce-margin-filter-select {\n  min-width: 100% !important;\n  max-width: 100% !important;\n}\n\n.agce-margin-filter-popup .agce-margin-filter-input {\n  width: 100%;\n}\n\n.agce-margin-filter-popup h6 {\n  color: #070808;\n}\n\n.agce-margin-filter-popup {\n  height: auto !important;\n  max-height: 80vh !important;\n  padding-bottom: 60px;\n}\n\n.agce-margin-filter-popup-content {\n  background: transparent !important;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 10px;\n  padding-bottom: 15px !important;\n}\n\n.agce-margin-filter-popup-content>* {\n  grid-column: 1 / -1;\n}\n\n.agce-margin-filter-popup-content>.agce-margin-filter-btn {\n  grid-column: span 1;\n}\n\n.agce-margin-filter-popup-content>.agce-margin-filter-arrow {\n  display: none !important;\n}\n\n.agce-margin-filter-apply-btn {\n  background: #000000 !important;\n  border: none !important;\n  border-radius: 50px !important;\n  font-weight: 600 !important;\n  padding: 8px !important;\n  font-size: 13px;\n  color: white;\n}\n\n.agce-margin-filter-apply-btn:hover,\n.agce-margin-filter-apply-btn:active {\n  background: #141414 !important;\n}\n\n.agce-margin-filter-checkbox-group {\n  margin-left: auto;\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.agce-margin-filter-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.agce-margin-filter-popup-content>.agce-margin-filter-checkbox-group {\n  grid-column: 1 / -1;\n  margin-left: 0;\n  justify-content: flex-start;\n}\n\n/* Mobile Asset History Card Classes */\n.agce-margin-card-wrap {\n  min-height: 200px;\n}\n\n.agce-margin-card-empty {\n  font-size: 12px;\n  color: #8e949e;\n}\n\n.agce-margin-card-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.agce-margin-card-pair {\n  font-weight: 600;\n}\n\n.agce-margin-card-time {\n  font-size: 11px;\n  color: #8e949e;\n}\n\n.agce-margin-card-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 12px;\n  font-size: 12px;\n}\n\n.agce-margin-card-label {\n  color: #8e949e;\n}\n\n.agce-margin-card-success {\n  color: #01bc8d;\n}\n\n.agce-margin-card-danger {\n  color: #e45561;\n}\n\n.agce-margin-card-grid>div:nth-child(even) {\n  text-align: right;\n}\n\n/* Position History Cards */\n.agce-margin-pos-card {\n  border-bottom: 1px solid var(--border-color, #efefef);\n  padding: 12px 16px;\n}\n\nhtml[data-theme=\"dark\"] .agce-margin-pos-card {\n  border-bottom: 1px solid #2b313c;\n}\n\n.agce-margin-pos-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.agce-margin-pos-cell {\n  flex: 1;\n}\n\n.agce-margin-pos-cell.text-right {\n  text-align: right;\n}\n\n.agce-margin-pos-lbl {\n  font-size: 11px;\n  color: #8e949e;\n  margin-bottom: 2px;\n}\n\n.agce-margin-pos-val-primary {\n  font-weight: 500;\n}\n\n.agce-margin-pos-val-secondary {\n  color: #8e949e;\n}\n\n.agce-margin-pos-pair-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 2px;\n}\n\n.agce-margin-pos-pair {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.agce-margin-pos-tag {\n  background: var(--bg-secondary, #f0f1f2);\n  border-radius: 4px;\n  padding: 1px 7px;\n  font-size: 12px;\n}\n\nhtml[data-theme=\"dark\"] .agce-margin-pos-tag {\n  background: #2b313c;\n}\n\n.agce-margin-pos-side-val {\n  font-weight: 700;\n  font-size: 15px;\n  margin-top: 2px;\n}\n\n.agce-margin-pos-asset {\n  color: #8e949e;\n  font-size: 11px;\n  margin-left: 3px;\n}\n\n.agce-margin-mobile-filter-wrap {\n  display: none;\n}\n\n\n@media (max-width: 1200px) {\n  .agce-margin-leverage-row {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .agce-margin-mobile-filter-wrap {\n    display: block;\n  }\n\n  .trade_account_summary_assets .mobile_view2 {\n    display: block;\n  }\n\n  .agce-margin-filter-popup {\n    padding-bottom: 10px;\n  }\n\n}\n\n\n@media (max-width: 991px) {\n\n\n  .agce-margin-filter-popup {\n    padding-bottom: 60px;\n  }\n\n  .agcx-add-funds-title {\n    font-size: 18px;\n  }\n\n  .agcx-add-funds-close {\n    font-size: 24px;\n    padding: 0px;\n  }\n\n  .order_history_mobile_view .agce-margin-pos-card {\n    padding: 12px 0px;\n  }\n\n}\n\n.agce-margin-order-type-container {\n  display: flex;\n  overflow-x: auto;\n  gap: 6px;\n  padding: 4px 0 6px;\n  align-items: center;\n}\n\n.agce-margin-order-type-btn {\n  flex-shrink: 0;\n  font-size: 12px;\n  padding: 3px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.agce-margin-order-type-btn.active {\n  background: #F6F6F7;\n  font-weight: 600;\n}\n\n/* --- LEVERAGE TOGGLE SWITCH UI --- */\n.agce-margin-leverage-trigger-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: none;\n  border: none;\n  padding: 4px 0 8px;\n  cursor: pointer;\n  outline: none;\n  font-family: \"Inter\", sans-serif;\n}\n\n/* Switch container wrapper */\n.agce-margin-leverage-switch-visual {\n  position: relative;\n  display: inline-block;\n  width: 34px;\n  height: 20px;\n  pointer-events: none;\n  /* Let click pass to the button */\n}\n\n/* Slider styling */\n.agce-margin-leverage-slider-visual {\n  position: absolute;\n  inset: 0;\n  background-color: #cbd5e1;\n  /* Off: gray */\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 999px;\n}\n\n/* Slider knob */\n.agce-margin-leverage-slider-visual:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n/* Active status styles */\n.agce-margin-leverage-slider-visual.is-active {\n  background-color: #d0aa67 !important;\n  /* Premium Emerald green */\n}\n\n.agce-margin-leverage-slider-visual.is-active:before {\n  transform: translateX(14px);\n}\n\n.agce-margin-leverage-label {\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.15s ease;\n}\n\n.agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {\n  color: #0f172a;\n}\n\n.agce-margin-leverage-value {\n  color: #0f172a;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.agce-margin-leverage-trigger-btn i {\n  font-size: 16px;\n  color: #64748b;\n  margin-left: 2px;\n}\n\n/* Dark mode compatibility */\nbody.dark_theme .agce-margin-leverage-slider-visual {\n  background-color: #475569;\n}\n\nbody.dark_theme .agce-margin-leverage-label {\n  color: #94a3b8;\n}\n\nbody.dark_theme .agce-margin-leverage-slider-visual.is-active~.agce-margin-leverage-label {\n  color: #f8fafc;\n}\n\nbody.dark_theme .agce-margin-leverage-value {\n  color: #f8fafc;\n}\n\n/* ==========================================\n   Dark Theme (Default) Overrides for Modals\n   ========================================== */\nbody:not(.light_theme) .agce-margin-lvg-modal-backdrop,\nbody:not(.light_theme) .agce-margin-ordty-modal-backdrop {\n  background: rgba(0, 0, 0, 0.7);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-panel,\nbody:not(.light_theme) .agce-margin-ordty-modal-panel {\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-head,\nbody:not(.light_theme) .agce-margin-ordty-modal-head {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-title,\nbody:not(.light_theme) .agce-margin-ordty-modal-title {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-close,\nbody:not(.light_theme) .agce-margin-ordty-modal-close {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-close:hover,\nbody:not(.light_theme) .agce-margin-ordty-modal-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-field-label {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-coin-row {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-input {\n  border-color: rgba(255, 255, 255, 0.15);\n  background: #1e2329;\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-input:focus {\n  border-color: #ffffff;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-quick button {\n  border-color: rgba(255, 255, 255, 0.1);\n  background: #1e2329;\n  color: #e2e8f0;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-quick button:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-quick button.is-active {\n  border-color: #ffffff;\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-stat dt {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-stat dd {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--ghost {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--primary {\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-btn--primary:hover {\n  background: #e2e8f0;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option {\n  border-color: rgba(255, 255, 255, 0.1);\n  background: #1e2329;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option:hover {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option.is-selected {\n  border-color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option-title {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-option-desc {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-btn-confirm {\n  background: #ffffff;\n  color: #111214;\n}\n\nbody:not(.light_theme) .agce-margin-ordty-btn-confirm:hover {\n  background: #e2e8f0;\n}\n\n/* ==========================================================================\n   AGCX Custom Filter Select Styles (Replaces default select dropdown popup)\n   ========================================================================== */\n\n.agce-custom-select-container {\n  position: relative;\n  width: auto;\n  min-width: 95px;\n  display: inline-block;\n  margin-right: 6px;\n  margin-bottom: 0;\n  vertical-align: middle;\n}\n\n.agce-custom-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 30px;\n  padding: 0 10px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 4px;\n  color: #eaecef;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s, background-color 0.2s;\n  gap: 8px;\n}\n\nbody.light_theme .agce-custom-select-trigger {\n  background: #f6f6f7;\n  border: 1px solid #cbd5e1;\n  color: #1e2329;\n}\n\n/* .agce-custom-select-trigger:focus,\n.agce-custom-select-trigger:hover {\n  border-color: #d1aa67;\n} */\n\n.agce-custom-select-trigger i {\n  font-size: 14px;\n  transition: transform 0.2s ease;\n  color: #848e9c;\n}\n\n.agce-custom-select-trigger i.open {\n  transform: rotate(180deg);\n}\n\n.agce-custom-select-options {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 100%;\n  width: max-content;\n  max-width: 200px;\n  max-height: 220px;\n  overflow-y: auto;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 6px;\n  z-index: 100000;\n  padding: 4px 0;\n  margin: 0;\n  list-style: none;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);\n  box-sizing: border-box;\n}\n\nbody.light_theme .agce-custom-select-options {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.agce-custom-select-option {\n  padding: 8px 14px;\n  font-size: 12px;\n  color: #eaecef;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.15s, color 0.15s;\n  white-space: nowrap;\n}\n\nbody.light_theme .agce-custom-select-option {\n  color: #1e2329;\n}\n\n.agce-custom-select-option:hover {\n  background: #2b3139;\n  color: #d1aa67;\n}\n\nbody.light_theme .agce-custom-select-option:hover {\n  background: #f1f5f9;\n  color: #d1aa67;\n}\n\n.agce-custom-select-option.selected {\n  background: rgba(209, 170, 103, 0.15);\n  color: #d1aa67;\n  font-weight: 600;\n}\n\nbody.light_theme .agce-custom-select-option.selected {\n  background: rgba(209, 170, 103, 0.1);\n  color: #d1aa67;\n  font-weight: 600;\n}\n\n/* Scrollbar customization for custom dropdown list */\n.agce-custom-select-options::-webkit-scrollbar {\n  width: 4px;\n}\n\n.agce-custom-select-options::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.agce-custom-select-options::-webkit-scrollbar-thumb {\n  background: #474f59;\n  border-radius: 4px;\n}\n\n.agce-margin-level-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.agce-margin-level-value {\n  font-weight: 600;\n}\n\n.agce-margin-level--safe,\n.agce-margin-level--normal {\n  color: #16a34a !important;\n}\n\n.agce-margin-level--margin_call {\n  color: #d97706 !important;\n}\n\n.agce-margin-level--liquidated {\n  color: #dc2626 !important;\n}\n\n.agce-margin-level--unavailable {\n  color: #9ca3af !important;\n}\n\n.agce-margin-level-indicator--wallet {\n  margin-top: 4px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n  line-height: 1.3;\n}\n\n.agce-margin-level-wallet--safe,\n.agce-margin-level-wallet--normal {\n  background: rgba(22, 163, 74, 0.12);\n}\n\n.agce-margin-level-wallet--margin_call {\n  background: rgba(217, 119, 6, 0.14);\n}\n\n.agce-margin-level-wallet--liquidated {\n  background: rgba(220, 38, 38, 0.12);\n}\n\n.agce-margin-level-wallet--unavailable {\n  background: rgba(156, 163, 175, 0.12);\n}\n\nbody.light_theme .agce-margin-level-wallet--safe,\nbody.light_theme .agce-margin-level-wallet--normal {\n  background: #e8f5e9;\n}\n\nbody.light_theme .agce-margin-level-wallet--margin_call {\n  background: #fff7ed;\n}\n\nbody.light_theme .agce-margin-level-wallet--liquidated {\n  background: #fef2f2;\n}\n\nbody.light_theme .agce-margin-level-wallet--unavailable {\n  background: #f3f4f6;\n}\n\n.margin-pro-page .funding-account__pair .agce-margin-level-value {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.spot_orders_table .agce-margin-level-indicator--wallet,\n.active-position-detail-value .agce-margin-level-indicator--wallet {\n  margin-top: 0;\n}\n\n.spot_orders_table .agce-margin-level-indicator--wallet .agce-margin-level-value,\n.active-position-detail-value .agce-margin-level-indicator--wallet .agce-margin-level-value {\n  font-size: 12px;\n}\n\n.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--normal,\n.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--safe,\n.active-position-detail-value .agce-margin-level-value.agce-margin-level--normal,\n.active-position-detail-value .agce-margin-level-value.agce-margin-level--safe {\n  color: #01bc8d !important;\n}\n\n.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--margin_call,\n.active-position-detail-value .agce-margin-level-value.agce-margin-level--margin_call {\n  color: #d97706 !important;\n}\n\n.spot_orders_table tbody td .agce-margin-level-value.agce-margin-level--liquidated,\n.active-position-detail-value .agce-margin-level-value.agce-margin-level--liquidated {\n  color: #dc2626 !important;\n}\n\n.margin-modal-container .margin-info-row .agce-margin-level-indicator {\n  justify-content: flex-end;\n}\n\n.agce-margin-level-info {\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n}\n\n.agce-margin-level-info-icon {\n  font-size: 12px;\n  color: #9ca3af;\n  cursor: pointer !important;\n}\n\n.agce-margin-level-tooltip {\n  min-width: 220px;\n  max-width: 280px;\n  white-space: normal;\n}\n\n.agce-margin-level-tooltip-value {\n  color: #9ca3af;\n  font-weight: 500;\n}\n\nbody.light_theme .agce-margin-level-tooltip-value {\n  color: #6b7280;\n}\n\n.agce-margin-level-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: transparent !important;\n  line-height: 1;\n  cursor: pointer !important;\n}\n\n.agce-margin-level-info-btn:focus-visible {\n  outline: 2px solid #d0aa67;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* Isolated Margin Risk modal */\n.agce-margin-risk-modal__dialog {\n  max-width: 440px !important;\n  margin: 1rem auto !important;\n}\n\n.agce-margin-risk-modal__content {\n  --agce-mr-text: #eaecef;\n  --agce-mr-muted: #848e9c;\n  --agce-mr-border: rgba(255, 255, 255, 0.08);\n  --agce-mr-surface: #1e2329;\n  --agce-mr-pill-safe-bg: rgba(22, 163, 74, 0.15);\n  --agce-mr-pill-safe-text: #4ade80;\n  --agce-mr-pill-normal-bg: rgba(22, 163, 74, 0.15);\n  --agce-mr-pill-normal-text: #4ade80;\n  --agce-mr-pill-call-bg: rgba(245, 158, 11, 0.18);\n  --agce-mr-pill-call-text: #fbbf24;\n  --agce-mr-pill-liq-bg: rgba(220, 38, 38, 0.18);\n  --agce-mr-pill-liq-text: #f87171;\n  --agce-mr-zone-danger: #ef4444;\n  --agce-mr-zone-warning: #f59e0b;\n  --agce-mr-zone-normal: #22c55e;\n  --agce-mr-active-bg: rgba(255, 255, 255, 0.04);\n\n  width: 100% !important;\n  max-width: 100% !important;\n  border-radius: 16px !important;\n  border: 1px solid var(--agce-mr-border) !important;\n  background: var(--agce-mr-surface) !important;\n  color: var(--agce-mr-text) !important;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.35) !important;\n  max-height: calc(100vh - 2rem);\n  overflow: hidden;\n}\n\nbody.light_theme .agce-margin-risk-modal__content {\n  --agce-mr-text: #1e2329;\n  --agce-mr-muted: #707a8a;\n  --agce-mr-border: #eef0f2;\n  --agce-mr-surface: #ffffff;\n  --agce-mr-pill-safe-bg: #ecfdf5;\n  --agce-mr-pill-safe-text: #15803d;\n  --agce-mr-pill-normal-bg: #ecfdf5;\n  --agce-mr-pill-normal-text: #15803d;\n  --agce-mr-pill-call-bg: #fff7ed;\n  --agce-mr-pill-call-text: #c2410c;\n  --agce-mr-pill-liq-bg: #fef2f2;\n  --agce-mr-pill-liq-text: #b91c1c;\n  --agce-mr-active-bg: #f9fafb;\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12) !important;\n}\n\n.agce-margin-risk-modal__close {\n  margin: 0 !important;\n  flex-shrink: 0;\n  opacity: 0.7;\n  filter: invert(1) grayscale(100%);\n}\n\nbody.light_theme .agce-margin-risk-modal__close {\n  filter: none;\n}\n\n.agce-margin-risk-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 20px 20px 0 !important;\n  border: none !important;\n}\n\n.agce-margin-risk-modal__title {\n  margin: 0 0 6px;\n  font-size: 1.125rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: var(--agce-mr-text);\n}\n\n.agce-margin-risk-modal__subtitle {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: var(--agce-mr-muted);\n}\n\n.agce-margin-risk-modal__body {\n  padding: 16px 20px 20px !important;\n}\n\n.agce-margin-risk-hero {\n  margin-bottom: 18px;\n}\n\n.agce-margin-risk-hero__top {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 12px;\n  margin-bottom: 8px;\n}\n\n.agce-margin-risk-hero__value {\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: -0.02em;\n  color: var(--agce-mr-text);\n}\n\n.agce-margin-risk-hero__value--safe {\n  color: var(--agce-mr-pill-safe-text);\n}\n\n.agce-margin-risk-hero__pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.agce-margin-risk-hero__pill--safe,\n.agce-margin-risk-hero__pill--normal {\n  background: var(--agce-mr-pill-normal-bg);\n  color: var(--agce-mr-pill-normal-text);\n}\n\n.agce-margin-risk-hero__pill--margin_call {\n  background: var(--agce-mr-pill-call-bg);\n  color: var(--agce-mr-pill-call-text);\n}\n\n.agce-margin-risk-hero__pill--liquidated {\n  background: var(--agce-mr-pill-liq-bg);\n  color: var(--agce-mr-pill-liq-text);\n}\n\n.agce-margin-risk-hero__pill--unavailable {\n  background: rgba(156, 163, 175, 0.15);\n  color: var(--agce-mr-muted);\n}\n\n.agce-margin-risk-hero__formula {\n  margin: 0;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: var(--agce-mr-muted);\n}\n\n.agce-margin-risk-meter {\n  margin-bottom: 20px;\n}\n\n.agce-margin-risk-meter__track {\n  position: relative;\n  display: flex;\n  height: 8px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: var(--agce-mr-border);\n}\n\n.agce-margin-risk-meter__zone {\n  height: 100%;\n  flex-shrink: 0;\n}\n\n.agce-margin-risk-meter__zone--danger {\n  background: var(--agce-mr-zone-danger);\n}\n\n.agce-margin-risk-meter__zone--warning {\n  background: var(--agce-mr-zone-warning);\n}\n\n.agce-margin-risk-meter__zone--normal {\n  flex: 1;\n  background: var(--agce-mr-zone-normal);\n}\n\n.agce-margin-risk-meter__marker {\n  position: absolute;\n  top: -3px;\n  width: 2px;\n  height: 14px;\n  margin-left: -1px;\n  background: var(--agce-mr-text);\n  border-radius: 1px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);\n}\n\n.agce-margin-risk-meter__labels {\n  position: relative;\n  height: 18px;\n  margin-top: 6px;\n}\n\n.agce-margin-risk-meter__label {\n  position: absolute;\n  transform: translateX(-50%);\n  font-size: 0.6875rem;\n  color: var(--agce-mr-muted);\n  white-space: nowrap;\n}\n\n.agce-margin-risk-tier-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.agce-margin-risk-tier {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 10px 12px;\n  border-radius: 10px;\n}\n\n.agce-margin-risk-tier--active {\n  background: var(--agce-mr-active-bg);\n}\n\n.agce-margin-risk-tier__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 5px;\n  flex-shrink: 0;\n}\n\n.agce-margin-risk-tier__dot--normal {\n  background: #22c55e;\n}\n\n.agce-margin-risk-tier__dot--warning {\n  background: #f59e0b;\n}\n\n.agce-margin-risk-tier__dot--danger {\n  background: #ef4444;\n}\n\n.agce-margin-risk-tier__content {\n  min-width: 0;\n}\n\n.agce-margin-risk-tier__title {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: var(--agce-mr-text);\n  margin-bottom: 2px;\n}\n\n.agce-margin-risk-tier__subtitle {\n  margin: 0;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: var(--agce-mr-muted);\n}\n\n.agce-margin-risk-modal__footnote,\n.agce-margin-risk-modal__loading {\n  margin: 0 0 16px;\n  padding-top: 14px;\n  border-top: 1px solid var(--agce-mr-border);\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: var(--agce-mr-muted);\n}\n\n.agce-margin-risk-modal__sections {\n  border-top: 1px solid var(--agce-mr-border);\n}\n\n.agce-margin-risk-section {\n  border-bottom: 1px solid var(--agce-mr-border);\n}\n\n.agce-margin-risk-section:last-child {\n  border-bottom: none;\n}\n\n.agce-margin-risk-section__header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 0;\n  border: none;\n  background: transparent;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--agce-mr-text);\n  cursor: pointer;\n  text-align: left;\n}\n\n.agce-margin-risk-section__header i {\n  font-size: 1rem;\n  color: var(--agce-mr-muted);\n  flex-shrink: 0;\n}\n\n.agce-margin-risk-section__body {\n  padding: 0 0 14px;\n}\n\n.agce-margin-risk-section__desc {\n  margin: 0 0 10px;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: var(--agce-mr-muted);\n}\n\n.agce-margin-risk-rules {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.agce-margin-risk-rule {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 8px 10px;\n  font-size: 0.8125rem;\n}\n\n.agce-margin-risk-rule__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--agce-mr-muted);\n  flex-shrink: 0;\n}\n\n.agce-margin-risk-rule__dot--ok {\n  background: #22c55e;\n}\n\n.agce-margin-risk-rule__label {\n  color: var(--agce-mr-text);\n  font-weight: 500;\n}\n\n.agce-margin-risk-rule__value {\n  color: var(--agce-mr-muted);\n  text-align: right;\n  font-size: 0.75rem;\n}\n\n@media (max-width: 575.98px) {\n  .agce-margin-risk-modal__dialog {\n    max-width: calc(100% - 1rem) !important;\n    margin: 0.5rem auto !important;\n  }\n\n  .agce-margin-risk-modal__content {\n    border-radius: 14px !important;\n    max-height: calc(100vh - 1rem);\n  }\n\n  .agce-margin-risk-modal__header {\n    padding: 16px 16px 0 !important;\n  }\n\n  .agce-margin-risk-modal__body {\n    padding: 14px 16px 16px !important;\n  }\n\n  .agce-margin-risk-hero__value {\n    font-size: 1.75rem;\n  }\n\n  .agce-margin-risk-rule {\n    grid-template-columns: auto 1fr;\n  }\n\n  .agce-margin-risk-rule__value {\n    grid-column: 2;\n    text-align: left;\n  }\n}\n\nbody.light_theme .agce-custom-select-options::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n}\n\n/* Mobile popup filter content adjustments */\n.agce-margin-filter-popup-content .agce-custom-select-container {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 12px;\n}\n\n.agce-margin-filter-popup-content .agce-custom-select-trigger {\n  height: 38px;\n  font-size: 13px;\n  padding: 0 12px;\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
